"use strict";

var _Object$keys2 = require("@babel/runtime-corejs2/core-js/object/keys");
var _Object$getOwnPropertySymbols = require("@babel/runtime-corejs2/core-js/object/get-own-property-symbols");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor");
var _Object$getOwnPropertyDescriptors = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptors");
var _Object$defineProperties = require("@babel/runtime-corejs2/core-js/object/define-properties");
var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ClusterModel = void 0;
require("core-js/modules/es6.function.name.js");
require("core-js/modules/es6.array.map.js");
require("core-js/modules/es6.array.filter.js");
require("core-js/modules/es6.string.includes.js");
require("core-js/modules/es7.array.includes.js");
require("core-js/modules/es6.regexp.split.js");
require("core-js/modules/es6.array.find.js");
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/slicedToArray"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/toConsumableArray"));
var _set = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/set"));
var _assign = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/assign"));
var _isArray = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/array/is-array"));
var _values = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/values"));
var _keys = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/keys"));
var _entries = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/entries"));
var _difference_in_calendar_days = _interopRequireDefault(require("date-fns/difference_in_calendar_days"));
var _format = _interopRequireDefault(require("date-fns/format"));
var _flatten = _interopRequireDefault(require("lodash/flatten"));
var _clone = _interopRequireDefault(require("lodash/clone"));
var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));
var _groupBy = _interopRequireDefault(require("lodash/groupBy"));
var _product = require("@nucleo/product");
var _calendar = require("@nucleo/calendar");
var _size = _interopRequireDefault(require("lodash/size"));
var _intersection = _interopRequireDefault(require("lodash/intersection"));
var _utils = require("@gravity/utils");
function cov_2qlmi16o15() {
  var path = "/codebuild/output/src2021135794/src/git-codecommit.eu-central-1.amazonaws.com/v1/repos/gravity/apps/tnwi/temp/nucleo/section/lib/model.js";
  var hash = "84f52b1dc559744a814a121a30e57c45b1a23c5a";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/codebuild/output/src2021135794/src/git-codecommit.eu-central-1.amazonaws.com/v1/repos/gravity/apps/tnwi/temp/nucleo/section/lib/model.js",
    statementMap: {
      "0": {
        start: {
          line: 14,
          column: 29
        },
        end: {
          line: 28,
          column: 1
        }
      },
      "1": {
        start: {
          line: 15,
          column: 2
        },
        end: {
          line: 17,
          column: 3
        }
      },
      "2": {
        start: {
          line: 16,
          column: 4
        },
        end: {
          line: 16,
          column: 14
        }
      },
      "3": {
        start: {
          line: 18,
          column: 21
        },
        end: {
          line: 18,
          column: 23
        }
      },
      "4": {
        start: {
          line: 19,
          column: 2
        },
        end: {
          line: 26,
          column: 5
        }
      },
      "5": {
        start: {
          line: 20,
          column: 4
        },
        end: {
          line: 22,
          column: 5
        }
      },
      "6": {
        start: {
          line: 21,
          column: 6
        },
        end: {
          line: 21,
          column: 13
        }
      },
      "7": {
        start: {
          line: 23,
          column: 4
        },
        end: {
          line: 25,
          column: 7
        }
      },
      "8": {
        start: {
          line: 24,
          column: 6
        },
        end: {
          line: 24,
          column: 39
        }
      },
      "9": {
        start: {
          line: 27,
          column: 2
        },
        end: {
          line: 27,
          column: 20
        }
      },
      "10": {
        start: {
          line: 34,
          column: 38
        },
        end: {
          line: 40,
          column: 1
        }
      },
      "11": {
        start: {
          line: 36,
          column: 2
        },
        end: {
          line: 38,
          column: 3
        }
      },
      "12": {
        start: {
          line: 37,
          column: 4
        },
        end: {
          line: 37,
          column: 95
        }
      },
      "13": {
        start: {
          line: 39,
          column: 2
        },
        end: {
          line: 39,
          column: 34
        }
      },
      "14": {
        start: {
          line: 45,
          column: 25
        },
        end: {
          line: 72,
          column: 1
        }
      },
      "15": {
        start: {
          line: 54,
          column: 24
        },
        end: {
          line: 56,
          column: 5
        }
      },
      "16": {
        start: {
          line: 57,
          column: 4
        },
        end: {
          line: 57,
          column: 39
        }
      },
      "17": {
        start: {
          line: 67,
          column: 24
        },
        end: {
          line: 69,
          column: 5
        }
      },
      "18": {
        start: {
          line: 70,
          column: 4
        },
        end: {
          line: 70,
          column: 46
        }
      },
      "19": {
        start: {
          line: 77,
          column: 28
        },
        end: {
          line: 184,
          column: 1
        }
      },
      "20": {
        start: {
          line: 86,
          column: 42
        },
        end: {
          line: 86,
          column: 48
        }
      },
      "21": {
        start: {
          line: 87,
          column: 24
        },
        end: {
          line: 91,
          column: 5
        }
      },
      "22": {
        start: {
          line: 92,
          column: 4
        },
        end: {
          line: 94,
          column: 5
        }
      },
      "23": {
        start: {
          line: 93,
          column: 6
        },
        end: {
          line: 93,
          column: 99
        }
      },
      "24": {
        start: {
          line: 93,
          column: 56
        },
        end: {
          line: 93,
          column: 97
        }
      },
      "25": {
        start: {
          line: 95,
          column: 4
        },
        end: {
          line: 95,
          column: 39
        }
      },
      "26": {
        start: {
          line: 106,
          column: 24
        },
        end: {
          line: 108,
          column: 5
        }
      },
      "27": {
        start: {
          line: 109,
          column: 4
        },
        end: {
          line: 113,
          column: 5
        }
      },
      "28": {
        start: {
          line: 110,
          column: 6
        },
        end: {
          line: 112,
          column: 8
        }
      },
      "29": {
        start: {
          line: 111,
          column: 8
        },
        end: {
          line: 111,
          column: 79
        }
      },
      "30": {
        start: {
          line: 114,
          column: 4
        },
        end: {
          line: 114,
          column: 42
        }
      },
      "31": {
        start: {
          line: 126,
          column: 23
        },
        end: {
          line: 126,
          column: 25
        }
      },
      "32": {
        start: {
          line: 127,
          column: 4
        },
        end: {
          line: 129,
          column: 7
        }
      },
      "33": {
        start: {
          line: 128,
          column: 6
        },
        end: {
          line: 128,
          column: 39
        }
      },
      "34": {
        start: {
          line: 130,
          column: 25
        },
        end: {
          line: 130,
          column: 27
        }
      },
      "35": {
        start: {
          line: 131,
          column: 4
        },
        end: {
          line: 171,
          column: 7
        }
      },
      "36": {
        start: {
          line: 132,
          column: 25
        },
        end: {
          line: 132,
          column: 61
        }
      },
      "37": {
        start: {
          line: 133,
          column: 6
        },
        end: {
          line: 170,
          column: 7
        }
      },
      "38": {
        start: {
          line: 134,
          column: 28
        },
        end: {
          line: 143,
          column: 11
        }
      },
      "39": {
        start: {
          line: 137,
          column: 14
        },
        end: {
          line: 137,
          column: 85
        }
      },
      "40": {
        start: {
          line: 142,
          column: 14
        },
        end: {
          line: 142,
          column: 94
        }
      },
      "41": {
        start: {
          line: 145,
          column: 8
        },
        end: {
          line: 148,
          column: 11
        }
      },
      "42": {
        start: {
          line: 149,
          column: 13
        },
        end: {
          line: 170,
          column: 7
        }
      },
      "43": {
        start: {
          line: 151,
          column: 26
        },
        end: {
          line: 153,
          column: 9
        }
      },
      "44": {
        start: {
          line: 152,
          column: 10
        },
        end: {
          line: 152,
          column: 60
        }
      },
      "45": {
        start: {
          line: 155,
          column: 8
        },
        end: {
          line: 158,
          column: 11
        }
      },
      "46": {
        start: {
          line: 159,
          column: 13
        },
        end: {
          line: 170,
          column: 7
        }
      },
      "47": {
        start: {
          line: 161,
          column: 29
        },
        end: {
          line: 163,
          column: 9
        }
      },
      "48": {
        start: {
          line: 162,
          column: 10
        },
        end: {
          line: 162,
          column: 67
        }
      },
      "49": {
        start: {
          line: 166,
          column: 8
        },
        end: {
          line: 169,
          column: 11
        }
      },
      "50": {
        start: {
          line: 172,
          column: 4
        },
        end: {
          line: 174,
          column: 6
        }
      },
      "51": {
        start: {
          line: 173,
          column: 6
        },
        end: {
          line: 173,
          column: 65
        }
      },
      "52": {
        start: {
          line: 175,
          column: 4
        },
        end: {
          line: 182,
          column: 6
        }
      },
      "53": {
        start: {
          line: 189,
          column: 21
        },
        end: {
          line: 786,
          column: 1
        }
      },
      "54": {
        start: {
          line: 198,
          column: 42
        },
        end: {
          line: 198,
          column: 48
        }
      },
      "55": {
        start: {
          line: 199,
          column: 24
        },
        end: {
          line: 203,
          column: 5
        }
      },
      "56": {
        start: {
          line: 204,
          column: 4
        },
        end: {
          line: 210,
          column: 5
        }
      },
      "57": {
        start: {
          line: 207,
          column: 6
        },
        end: {
          line: 209,
          column: 8
        }
      },
      "58": {
        start: {
          line: 208,
          column: 19
        },
        end: {
          line: 208,
          column: 52
        }
      },
      "59": {
        start: {
          line: 211,
          column: 4
        },
        end: {
          line: 211,
          column: 39
        }
      },
      "60": {
        start: {
          line: 223,
          column: 4
        },
        end: {
          line: 230,
          column: 6
        }
      },
      "61": {
        start: {
          line: 224,
          column: 21
        },
        end: {
          line: 224,
          column: 35
        }
      },
      "62": {
        start: {
          line: 225,
          column: 6
        },
        end: {
          line: 225,
          column: 80
        }
      },
      "63": {
        start: {
          line: 226,
          column: 6
        },
        end: {
          line: 228,
          column: 8
        }
      },
      "64": {
        start: {
          line: 227,
          column: 8
        },
        end: {
          line: 227,
          column: 71
        }
      },
      "65": {
        start: {
          line: 229,
          column: 6
        },
        end: {
          line: 229,
          column: 20
        }
      },
      "66": {
        start: {
          line: 241,
          column: 42
        },
        end: {
          line: 241,
          column: 48
        }
      },
      "67": {
        start: {
          line: 242,
          column: 17
        },
        end: {
          line: 242,
          column: 19
        }
      },
      "68": {
        start: {
          line: 244,
          column: 4
        },
        end: {
          line: 269,
          column: 5
        }
      },
      "69": {
        start: {
          line: 247,
          column: 8
        },
        end: {
          line: 247,
          column: 68
        }
      },
      "70": {
        start: {
          line: 250,
          column: 8
        },
        end: {
          line: 250,
          column: 66
        }
      },
      "71": {
        start: {
          line: 253,
          column: 8
        },
        end: {
          line: 253,
          column: 65
        }
      },
      "72": {
        start: {
          line: 256,
          column: 8
        },
        end: {
          line: 256,
          column: 28
        }
      },
      "73": {
        start: {
          line: 257,
          column: 8
        },
        end: {
          line: 257,
          column: 35
        }
      },
      "74": {
        start: {
          line: 259,
          column: 8
        },
        end: {
          line: 264,
          column: 10
        }
      },
      "75": {
        start: {
          line: 262,
          column: 55
        },
        end: {
          line: 262,
          column: 68
        }
      },
      "76": {
        start: {
          line: 268,
          column: 8
        },
        end: {
          line: 268,
          column: 28
        }
      },
      "77": {
        start: {
          line: 280,
          column: 42
        },
        end: {
          line: 280,
          column: 48
        }
      },
      "78": {
        start: {
          line: 281,
          column: 24
        },
        end: {
          line: 281,
          column: 26
        }
      },
      "79": {
        start: {
          line: 282,
          column: 4
        },
        end: {
          line: 304,
          column: 7
        }
      },
      "80": {
        start: {
          line: 283,
          column: 6
        },
        end: {
          line: 303,
          column: 9
        }
      },
      "81": {
        start: {
          line: 285,
          column: 17
        },
        end: {
          line: 285,
          column: 41
        }
      },
      "82": {
        start: {
          line: 287,
          column: 8
        },
        end: {
          line: 289,
          column: 9
        }
      },
      "83": {
        start: {
          line: 288,
          column: 10
        },
        end: {
          line: 288,
          column: 22
        }
      },
      "84": {
        start: {
          line: 291,
          column: 8
        },
        end: {
          line: 293,
          column: 9
        }
      },
      "85": {
        start: {
          line: 292,
          column: 10
        },
        end: {
          line: 292,
          column: 23
        }
      },
      "86": {
        start: {
          line: 294,
          column: 21
        },
        end: {
          line: 294,
          column: 23
        }
      },
      "87": {
        start: {
          line: 295,
          column: 8
        },
        end: {
          line: 295,
          column: 28
        }
      },
      "88": {
        start: {
          line: 296,
          column: 8
        },
        end: {
          line: 296,
          column: 35
        }
      },
      "89": {
        start: {
          line: 297,
          column: 8
        },
        end: {
          line: 300,
          column: 10
        }
      },
      "90": {
        start: {
          line: 302,
          column: 8
        },
        end: {
          line: 302,
          column: 41
        }
      },
      "91": {
        start: {
          line: 305,
          column: 4
        },
        end: {
          line: 305,
          column: 38
        }
      },
      "92": {
        start: {
          line: 315,
          column: 64
        },
        end: {
          line: 315,
          column: 70
        }
      },
      "93": {
        start: {
          line: 316,
          column: 27
        },
        end: {
          line: 316,
          column: 58
        }
      },
      "94": {
        start: {
          line: 317,
          column: 18
        },
        end: {
          line: 317,
          column: 65
        }
      },
      "95": {
        start: {
          line: 317,
          column: 50
        },
        end: {
          line: 317,
          column: 63
        }
      },
      "96": {
        start: {
          line: 319,
          column: 23
        },
        end: {
          line: 319,
          column: 33
        }
      },
      "97": {
        start: {
          line: 320,
          column: 21
        },
        end: {
          line: 320,
          column: 82
        }
      },
      "98": {
        start: {
          line: 321,
          column: 18
        },
        end: {
          line: 321,
          column: 53
        }
      },
      "99": {
        start: {
          line: 323,
          column: 20
        },
        end: {
          line: 323,
          column: 71
        }
      },
      "100": {
        start: {
          line: 323,
          column: 28
        },
        end: {
          line: 323,
          column: 71
        }
      },
      "101": {
        start: {
          line: 324,
          column: 23
        },
        end: {
          line: 324,
          column: 74
        }
      },
      "102": {
        start: {
          line: 324,
          column: 31
        },
        end: {
          line: 324,
          column: 74
        }
      },
      "103": {
        start: {
          line: 325,
          column: 28
        },
        end: {
          line: 325,
          column: 79
        }
      },
      "104": {
        start: {
          line: 325,
          column: 36
        },
        end: {
          line: 325,
          column: 79
        }
      },
      "105": {
        start: {
          line: 326,
          column: 20
        },
        end: {
          line: 326,
          column: 89
        }
      },
      "106": {
        start: {
          line: 326,
          column: 28
        },
        end: {
          line: 326,
          column: 89
        }
      },
      "107": {
        start: {
          line: 328,
          column: 24
        },
        end: {
          line: 333,
          column: 5
        }
      },
      "108": {
        start: {
          line: 335,
          column: 4
        },
        end: {
          line: 360,
          column: 7
        }
      },
      "109": {
        start: {
          line: 336,
          column: 21
        },
        end: {
          line: 336,
          column: 26
        }
      },
      "110": {
        start: {
          line: 337,
          column: 24
        },
        end: {
          line: 337,
          column: 29
        }
      },
      "111": {
        start: {
          line: 338,
          column: 29
        },
        end: {
          line: 338,
          column: 34
        }
      },
      "112": {
        start: {
          line: 341,
          column: 6
        },
        end: {
          line: 354,
          column: 9
        }
      },
      "113": {
        start: {
          line: 342,
          column: 8
        },
        end: {
          line: 345,
          column: 9
        }
      },
      "114": {
        start: {
          line: 343,
          column: 10
        },
        end: {
          line: 343,
          column: 26
        }
      },
      "115": {
        start: {
          line: 344,
          column: 10
        },
        end: {
          line: 344,
          column: 39
        }
      },
      "116": {
        start: {
          line: 346,
          column: 8
        },
        end: {
          line: 349,
          column: 9
        }
      },
      "117": {
        start: {
          line: 347,
          column: 10
        },
        end: {
          line: 347,
          column: 29
        }
      },
      "118": {
        start: {
          line: 348,
          column: 10
        },
        end: {
          line: 348,
          column: 42
        }
      },
      "119": {
        start: {
          line: 350,
          column: 8
        },
        end: {
          line: 353,
          column: 9
        }
      },
      "120": {
        start: {
          line: 351,
          column: 10
        },
        end: {
          line: 351,
          column: 34
        }
      },
      "121": {
        start: {
          line: 352,
          column: 10
        },
        end: {
          line: 352,
          column: 47
        }
      },
      "122": {
        start: {
          line: 355,
          column: 23
        },
        end: {
          line: 355,
          column: 60
        }
      },
      "123": {
        start: {
          line: 357,
          column: 6
        },
        end: {
          line: 359,
          column: 7
        }
      },
      "124": {
        start: {
          line: 358,
          column: 8
        },
        end: {
          line: 358,
          column: 37
        }
      },
      "125": {
        start: {
          line: 361,
          column: 24
        },
        end: {
          line: 361,
          column: 26
        }
      },
      "126": {
        start: {
          line: 363,
          column: 24
        },
        end: {
          line: 368,
          column: 5
        }
      },
      "127": {
        start: {
          line: 367,
          column: 19
        },
        end: {
          line: 367,
          column: 24
        }
      },
      "128": {
        start: {
          line: 370,
          column: 4
        },
        end: {
          line: 400,
          column: 7
        }
      },
      "129": {
        start: {
          line: 371,
          column: 6
        },
        end: {
          line: 373,
          column: 7
        }
      },
      "130": {
        start: {
          line: 372,
          column: 8
        },
        end: {
          line: 372,
          column: 15
        }
      },
      "131": {
        start: {
          line: 374,
          column: 23
        },
        end: {
          line: 374,
          column: 39
        }
      },
      "132": {
        start: {
          line: 375,
          column: 25
        },
        end: {
          line: 375,
          column: 52
        }
      },
      "133": {
        start: {
          line: 375,
          column: 32
        },
        end: {
          line: 375,
          column: 52
        }
      },
      "134": {
        start: {
          line: 376,
          column: 23
        },
        end: {
          line: 392,
          column: 8
        }
      },
      "135": {
        start: {
          line: 377,
          column: 24
        },
        end: {
          line: 379,
          column: 9
        }
      },
      "136": {
        start: {
          line: 380,
          column: 8
        },
        end: {
          line: 380,
          column: 46
        }
      },
      "137": {
        start: {
          line: 381,
          column: 25
        },
        end: {
          line: 381,
          column: 65
        }
      },
      "138": {
        start: {
          line: 381,
          column: 32
        },
        end: {
          line: 381,
          column: 65
        }
      },
      "139": {
        start: {
          line: 382,
          column: 8
        },
        end: {
          line: 384,
          column: 9
        }
      },
      "140": {
        start: {
          line: 383,
          column: 10
        },
        end: {
          line: 383,
          column: 87
        }
      },
      "141": {
        start: {
          line: 385,
          column: 8
        },
        end: {
          line: 387,
          column: 9
        }
      },
      "142": {
        start: {
          line: 386,
          column: 10
        },
        end: {
          line: 386,
          column: 81
        }
      },
      "143": {
        start: {
          line: 388,
          column: 8
        },
        end: {
          line: 390,
          column: 9
        }
      },
      "144": {
        start: {
          line: 389,
          column: 10
        },
        end: {
          line: 389,
          column: 85
        }
      },
      "145": {
        start: {
          line: 391,
          column: 8
        },
        end: {
          line: 391,
          column: 23
        }
      },
      "146": {
        start: {
          line: 393,
          column: 19
        },
        end: {
          line: 393,
          column: 21
        }
      },
      "147": {
        start: {
          line: 394,
          column: 6
        },
        end: {
          line: 394,
          column: 27
        }
      },
      "148": {
        start: {
          line: 395,
          column: 6
        },
        end: {
          line: 395,
          column: 34
        }
      },
      "149": {
        start: {
          line: 396,
          column: 6
        },
        end: {
          line: 399,
          column: 9
        }
      },
      "150": {
        start: {
          line: 402,
          column: 4
        },
        end: {
          line: 402,
          column: 23
        }
      },
      "151": {
        start: {
          line: 411,
          column: 42
        },
        end: {
          line: 411,
          column: 48
        }
      },
      "152": {
        start: {
          line: 413,
          column: 24
        },
        end: {
          line: 413,
          column: 26
        }
      },
      "153": {
        start: {
          line: 415,
          column: 26
        },
        end: {
          line: 415,
          column: 28
        }
      },
      "154": {
        start: {
          line: 417,
          column: 28
        },
        end: {
          line: 417,
          column: 30
        }
      },
      "155": {
        start: {
          line: 419,
          column: 4
        },
        end: {
          line: 463,
          column: 7
        }
      },
      "156": {
        start: {
          line: 420,
          column: 6
        },
        end: {
          line: 462,
          column: 9
        }
      },
      "157": {
        start: {
          line: 421,
          column: 28
        },
        end: {
          line: 421,
          column: 76
        }
      },
      "158": {
        start: {
          line: 422,
          column: 24
        },
        end: {
          line: 422,
          column: 56
        }
      },
      "159": {
        start: {
          line: 423,
          column: 8
        },
        end: {
          line: 425,
          column: 9
        }
      },
      "160": {
        start: {
          line: 424,
          column: 10
        },
        end: {
          line: 424,
          column: 17
        }
      },
      "161": {
        start: {
          line: 426,
          column: 26
        },
        end: {
          line: 426,
          column: 48
        }
      },
      "162": {
        start: {
          line: 427,
          column: 8
        },
        end: {
          line: 461,
          column: 11
        }
      },
      "163": {
        start: {
          line: 429,
          column: 22
        },
        end: {
          line: 429,
          column: 67
        }
      },
      "164": {
        start: {
          line: 431,
          column: 31
        },
        end: {
          line: 431,
          column: 69
        }
      },
      "165": {
        start: {
          line: 432,
          column: 10
        },
        end: {
          line: 460,
          column: 11
        }
      },
      "166": {
        start: {
          line: 434,
          column: 12
        },
        end: {
          line: 440,
          column: 15
        }
      },
      "167": {
        start: {
          line: 442,
          column: 12
        },
        end: {
          line: 456,
          column: 13
        }
      },
      "168": {
        start: {
          line: 443,
          column: 14
        },
        end: {
          line: 443,
          column: 46
        }
      },
      "169": {
        start: {
          line: 444,
          column: 14
        },
        end: {
          line: 444,
          column: 52
        }
      },
      "170": {
        start: {
          line: 446,
          column: 30
        },
        end: {
          line: 446,
          column: 32
        }
      },
      "171": {
        start: {
          line: 448,
          column: 14
        },
        end: {
          line: 448,
          column: 38
        }
      },
      "172": {
        start: {
          line: 449,
          column: 14
        },
        end: {
          line: 449,
          column: 45
        }
      },
      "173": {
        start: {
          line: 450,
          column: 14
        },
        end: {
          line: 453,
          column: 16
        }
      },
      "174": {
        start: {
          line: 454,
          column: 14
        },
        end: {
          line: 454,
          column: 46
        }
      },
      "175": {
        start: {
          line: 455,
          column: 14
        },
        end: {
          line: 455,
          column: 43
        }
      },
      "176": {
        start: {
          line: 459,
          column: 12
        },
        end: {
          line: 459,
          column: 96
        }
      },
      "177": {
        start: {
          line: 464,
          column: 4
        },
        end: {
          line: 464,
          column: 23
        }
      },
      "178": {
        start: {
          line: 475,
          column: 42
        },
        end: {
          line: 475,
          column: 48
        }
      },
      "179": {
        start: {
          line: 476,
          column: 22
        },
        end: {
          line: 476,
          column: 67
        }
      },
      "180": {
        start: {
          line: 477,
          column: 18
        },
        end: {
          line: 477,
          column: 46
        }
      },
      "181": {
        start: {
          line: 478,
          column: 17
        },
        end: {
          line: 478,
          column: 19
        }
      },
      "182": {
        start: {
          line: 479,
          column: 4
        },
        end: {
          line: 479,
          column: 27
        }
      },
      "183": {
        start: {
          line: 480,
          column: 4
        },
        end: {
          line: 480,
          column: 34
        }
      },
      "184": {
        start: {
          line: 483,
          column: 27
        },
        end: {
          line: 493,
          column: 5
        }
      },
      "185": {
        start: {
          line: 495,
          column: 21
        },
        end: {
          line: 504,
          column: 6
        }
      },
      "186": {
        start: {
          line: 496,
          column: 21
        },
        end: {
          line: 496,
          column: 65
        }
      },
      "187": {
        start: {
          line: 497,
          column: 26
        },
        end: {
          line: 497,
          column: 28
        }
      },
      "188": {
        start: {
          line: 498,
          column: 6
        },
        end: {
          line: 498,
          column: 37
        }
      },
      "189": {
        start: {
          line: 499,
          column: 6
        },
        end: {
          line: 499,
          column: 44
        }
      },
      "190": {
        start: {
          line: 501,
          column: 19
        },
        end: {
          line: 501,
          column: 93
        }
      },
      "191": {
        start: {
          line: 501,
          column: 37
        },
        end: {
          line: 501,
          column: 92
        }
      },
      "192": {
        start: {
          line: 503,
          column: 6
        },
        end: {
          line: 503,
          column: 78
        }
      },
      "193": {
        start: {
          line: 506,
          column: 20
        },
        end: {
          line: 508,
          column: 6
        }
      },
      "194": {
        start: {
          line: 511,
          column: 4
        },
        end: {
          line: 511,
          column: 19
        }
      },
      "195": {
        start: {
          line: 522,
          column: 21
        },
        end: {
          line: 522,
          column: 46
        }
      },
      "196": {
        start: {
          line: 523,
          column: 25
        },
        end: {
          line: 523,
          column: 27
        }
      },
      "197": {
        start: {
          line: 524,
          column: 18
        },
        end: {
          line: 524,
          column: 20
        }
      },
      "198": {
        start: {
          line: 525,
          column: 4
        },
        end: {
          line: 531,
          column: 6
        }
      },
      "199": {
        start: {
          line: 526,
          column: 6
        },
        end: {
          line: 530,
          column: 8
        }
      },
      "200": {
        start: {
          line: 527,
          column: 30
        },
        end: {
          line: 527,
          column: 56
        }
      },
      "201": {
        start: {
          line: 528,
          column: 8
        },
        end: {
          line: 528,
          column: 51
        }
      },
      "202": {
        start: {
          line: 529,
          column: 8
        },
        end: {
          line: 529,
          column: 86
        }
      },
      "203": {
        start: {
          line: 533,
          column: 4
        },
        end: {
          line: 542,
          column: 7
        }
      },
      "204": {
        start: {
          line: 534,
          column: 6
        },
        end: {
          line: 541,
          column: 9
        }
      },
      "205": {
        start: {
          line: 535,
          column: 21
        },
        end: {
          line: 538,
          column: 9
        }
      },
      "206": {
        start: {
          line: 539,
          column: 8
        },
        end: {
          line: 539,
          column: 31
        }
      },
      "207": {
        start: {
          line: 540,
          column: 8
        },
        end: {
          line: 540,
          column: 25
        }
      },
      "208": {
        start: {
          line: 544,
          column: 4
        },
        end: {
          line: 544,
          column: 17
        }
      },
      "209": {
        start: {
          line: 550,
          column: 4
        },
        end: {
          line: 554,
          column: 5
        }
      },
      "210": {
        start: {
          line: 551,
          column: 6
        },
        end: {
          line: 553,
          column: 9
        }
      },
      "211": {
        start: {
          line: 552,
          column: 50
        },
        end: {
          line: 552,
          column: 66
        }
      },
      "212": {
        start: {
          line: 555,
          column: 4
        },
        end: {
          line: 555,
          column: 14
        }
      },
      "213": {
        start: {
          line: 564,
          column: 28
        },
        end: {
          line: 567,
          column: 7
        }
      },
      "214": {
        start: {
          line: 564,
          column: 53
        },
        end: {
          line: 567,
          column: 5
        }
      },
      "215": {
        start: {
          line: 569,
          column: 21
        },
        end: {
          line: 572,
          column: 7
        }
      },
      "216": {
        start: {
          line: 569,
          column: 54
        },
        end: {
          line: 572,
          column: 5
        }
      },
      "217": {
        start: {
          line: 574,
          column: 29
        },
        end: {
          line: 575,
          column: 73
        }
      },
      "218": {
        start: {
          line: 577,
          column: 4
        },
        end: {
          line: 582,
          column: 6
        }
      },
      "219": {
        start: {
          line: 594,
          column: 42
        },
        end: {
          line: 594,
          column: 48
        }
      },
      "220": {
        start: {
          line: 595,
          column: 17
        },
        end: {
          line: 595,
          column: 19
        }
      },
      "221": {
        start: {
          line: 596,
          column: 24
        },
        end: {
          line: 596,
          column: 40
        }
      },
      "222": {
        start: {
          line: 598,
          column: 4
        },
        end: {
          line: 598,
          column: 62
        }
      },
      "223": {
        start: {
          line: 599,
          column: 4
        },
        end: {
          line: 599,
          column: 76
        }
      },
      "224": {
        start: {
          line: 602,
          column: 27
        },
        end: {
          line: 610,
          column: 5
        }
      },
      "225": {
        start: {
          line: 613,
          column: 25
        },
        end: {
          line: 616,
          column: 7
        }
      },
      "226": {
        start: {
          line: 613,
          column: 47
        },
        end: {
          line: 616,
          column: 5
        }
      },
      "227": {
        start: {
          line: 619,
          column: 20
        },
        end: {
          line: 627,
          column: 5
        }
      },
      "228": {
        start: {
          line: 629,
          column: 4
        },
        end: {
          line: 631,
          column: 7
        }
      },
      "229": {
        start: {
          line: 655,
          column: 42
        },
        end: {
          line: 655,
          column: 48
        }
      },
      "230": {
        start: {
          line: 657,
          column: 24
        },
        end: {
          line: 657,
          column: 60
        }
      },
      "231": {
        start: {
          line: 658,
          column: 17
        },
        end: {
          line: 658,
          column: 19
        }
      },
      "232": {
        start: {
          line: 659,
          column: 27
        },
        end: {
          line: 659,
          column: 29
        }
      },
      "233": {
        start: {
          line: 661,
          column: 27
        },
        end: {
          line: 661,
          column: 29
        }
      },
      "234": {
        start: {
          line: 662,
          column: 25
        },
        end: {
          line: 662,
          column: 29
        }
      },
      "235": {
        start: {
          line: 665,
          column: 33
        },
        end: {
          line: 667,
          column: 5
        }
      },
      "236": {
        start: {
          line: 666,
          column: 6
        },
        end: {
          line: 666,
          column: 54
        }
      },
      "237": {
        start: {
          line: 670,
          column: 4
        },
        end: {
          line: 722,
          column: 7
        }
      },
      "238": {
        start: {
          line: 671,
          column: 20
        },
        end: {
          line: 671,
          column: 24
        }
      },
      "239": {
        start: {
          line: 672,
          column: 29
        },
        end: {
          line: 672,
          column: 42
        }
      },
      "240": {
        start: {
          line: 673,
          column: 33
        },
        end: {
          line: 673,
          column: 46
        }
      },
      "241": {
        start: {
          line: 675,
          column: 26
        },
        end: {
          line: 675,
          column: 69
        }
      },
      "242": {
        start: {
          line: 678,
          column: 6
        },
        end: {
          line: 694,
          column: 7
        }
      },
      "243": {
        start: {
          line: 679,
          column: 8
        },
        end: {
          line: 679,
          column: 39
        }
      },
      "244": {
        start: {
          line: 680,
          column: 8
        },
        end: {
          line: 680,
          column: 37
        }
      },
      "245": {
        start: {
          line: 681,
          column: 8
        },
        end: {
          line: 681,
          column: 44
        }
      },
      "246": {
        start: {
          line: 684,
          column: 8
        },
        end: {
          line: 693,
          column: 10
        }
      },
      "247": {
        start: {
          line: 696,
          column: 21
        },
        end: {
          line: 696,
          column: 67
        }
      },
      "248": {
        start: {
          line: 697,
          column: 26
        },
        end: {
          line: 697,
          column: 28
        }
      },
      "249": {
        start: {
          line: 698,
          column: 25
        },
        end: {
          line: 698,
          column: 27
        }
      },
      "250": {
        start: {
          line: 699,
          column: 28
        },
        end: {
          line: 699,
          column: 30
        }
      },
      "251": {
        start: {
          line: 702,
          column: 6
        },
        end: {
          line: 705,
          column: 9
        }
      },
      "252": {
        start: {
          line: 704,
          column: 8
        },
        end: {
          line: 704,
          column: 84
        }
      },
      "253": {
        start: {
          line: 707,
          column: 6
        },
        end: {
          line: 707,
          column: 37
        }
      },
      "254": {
        start: {
          line: 708,
          column: 6
        },
        end: {
          line: 708,
          column: 44
        }
      },
      "255": {
        start: {
          line: 710,
          column: 6
        },
        end: {
          line: 710,
          column: 81
        }
      },
      "256": {
        start: {
          line: 711,
          column: 6
        },
        end: {
          line: 711,
          column: 60
        }
      },
      "257": {
        start: {
          line: 713,
          column: 6
        },
        end: {
          line: 713,
          column: 86
        }
      },
      "258": {
        start: {
          line: 715,
          column: 23
        },
        end: {
          line: 717,
          column: 19
        }
      },
      "259": {
        start: {
          line: 719,
          column: 6
        },
        end: {
          line: 721,
          column: 9
        }
      },
      "260": {
        start: {
          line: 724,
          column: 4
        },
        end: {
          line: 724,
          column: 26
        }
      },
      "261": {
        start: {
          line: 731,
          column: 4
        },
        end: {
          line: 734,
          column: 66
        }
      },
      "262": {
        start: {
          line: 734,
          column: 37
        },
        end: {
          line: 734,
          column: 65
        }
      },
      "263": {
        start: {
          line: 737,
          column: 22
        },
        end: {
          line: 737,
          column: 34
        }
      },
      "264": {
        start: {
          line: 740,
          column: 4
        },
        end: {
          line: 742,
          column: 5
        }
      },
      "265": {
        start: {
          line: 741,
          column: 6
        },
        end: {
          line: 741,
          column: 21
        }
      },
      "266": {
        start: {
          line: 743,
          column: 29
        },
        end: {
          line: 743,
          column: 66
        }
      },
      "267": {
        start: {
          line: 745,
          column: 4
        },
        end: {
          line: 755,
          column: 5
        }
      },
      "268": {
        start: {
          line: 746,
          column: 6
        },
        end: {
          line: 750,
          column: 7
        }
      },
      "269": {
        start: {
          line: 747,
          column: 8
        },
        end: {
          line: 747,
          column: 50
        }
      },
      "270": {
        start: {
          line: 749,
          column: 8
        },
        end: {
          line: 749,
          column: 47
        }
      },
      "271": {
        start: {
          line: 751,
          column: 11
        },
        end: {
          line: 755,
          column: 5
        }
      },
      "272": {
        start: {
          line: 752,
          column: 6
        },
        end: {
          line: 752,
          column: 90
        }
      },
      "273": {
        start: {
          line: 752,
          column: 57
        },
        end: {
          line: 752,
          column: 88
        }
      },
      "274": {
        start: {
          line: 754,
          column: 6
        },
        end: {
          line: 754,
          column: 31
        }
      },
      "275": {
        start: {
          line: 757,
          column: 4
        },
        end: {
          line: 760,
          column: 6
        }
      },
      "276": {
        start: {
          line: 767,
          column: 4
        },
        end: {
          line: 775,
          column: 5
        }
      },
      "277": {
        start: {
          line: 769,
          column: 32
        },
        end: {
          line: 769,
          column: 71
        }
      },
      "278": {
        start: {
          line: 769,
          column: 58
        },
        end: {
          line: 769,
          column: 70
        }
      },
      "279": {
        start: {
          line: 770,
          column: 8
        },
        end: {
          line: 772,
          column: 9
        }
      },
      "280": {
        start: {
          line: 771,
          column: 10
        },
        end: {
          line: 771,
          column: 93
        }
      },
      "281": {
        start: {
          line: 771,
          column: 51
        },
        end: {
          line: 771,
          column: 91
        }
      },
      "282": {
        start: {
          line: 773,
          column: 8
        },
        end: {
          line: 773,
          column: 31
        }
      },
      "283": {
        start: {
          line: 781,
          column: 4
        },
        end: {
          line: 785,
          column: 5
        }
      },
      "284": {
        start: {
          line: 783,
          column: 27
        },
        end: {
          line: 783,
          column: 111
        }
      },
      "285": {
        start: {
          line: 784,
          column: 24
        },
        end: {
          line: 784,
          column: 86
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 14,
            column: 29
          },
          end: {
            line: 14,
            column: 30
          }
        },
        loc: {
          start: {
            line: 14,
            column: 40
          },
          end: {
            line: 28,
            column: 1
          }
        },
        line: 14
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 19,
            column: 27
          },
          end: {
            line: 19,
            column: 28
          }
        },
        loc: {
          start: {
            line: 19,
            column: 38
          },
          end: {
            line: 26,
            column: 3
          }
        },
        line: 19
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 23,
            column: 26
          },
          end: {
            line: 23,
            column: 27
          }
        },
        loc: {
          start: {
            line: 23,
            column: 34
          },
          end: {
            line: 25,
            column: 5
          }
        },
        line: 23
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 34,
            column: 38
          },
          end: {
            line: 34,
            column: 39
          }
        },
        loc: {
          start: {
            line: 34,
            column: 61
          },
          end: {
            line: 40,
            column: 1
          }
        },
        line: 34
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 53,
            column: 7
          },
          end: {
            line: 53,
            column: 8
          }
        },
        loc: {
          start: {
            line: 53,
            column: 25
          },
          end: {
            line: 58,
            column: 3
          }
        },
        line: 53
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 66,
            column: 18
          },
          end: {
            line: 66,
            column: 19
          }
        },
        loc: {
          start: {
            line: 66,
            column: 62
          },
          end: {
            line: 71,
            column: 3
          }
        },
        line: 66
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 85,
            column: 7
          },
          end: {
            line: 85,
            column: 8
          }
        },
        loc: {
          start: {
            line: 85,
            column: 25
          },
          end: {
            line: 96,
            column: 3
          }
        },
        line: 85
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 93,
            column: 41
          },
          end: {
            line: 93,
            column: 42
          }
        },
        loc: {
          start: {
            line: 93,
            column: 56
          },
          end: {
            line: 93,
            column: 97
          }
        },
        line: 93
      },
      "8": {
        name: "(anonymous_8)",
        decl: {
          start: {
            line: 105,
            column: 18
          },
          end: {
            line: 105,
            column: 19
          }
        },
        loc: {
          start: {
            line: 105,
            column: 58
          },
          end: {
            line: 115,
            column: 3
          }
        },
        line: 105
      },
      "9": {
        name: "(anonymous_9)",
        decl: {
          start: {
            line: 110,
            column: 44
          },
          end: {
            line: 110,
            column: 45
          }
        },
        loc: {
          start: {
            line: 111,
            column: 8
          },
          end: {
            line: 111,
            column: 79
          }
        },
        line: 111
      },
      "10": {
        name: "(anonymous_10)",
        decl: {
          start: {
            line: 125,
            column: 16
          },
          end: {
            line: 125,
            column: 17
          }
        },
        loc: {
          start: {
            line: 125,
            column: 56
          },
          end: {
            line: 183,
            column: 3
          }
        },
        line: 125
      },
      "11": {
        name: "(anonymous_11)",
        decl: {
          start: {
            line: 127,
            column: 21
          },
          end: {
            line: 127,
            column: 22
          }
        },
        loc: {
          start: {
            line: 127,
            column: 32
          },
          end: {
            line: 129,
            column: 5
          }
        },
        line: 127
      },
      "12": {
        name: "(anonymous_12)",
        decl: {
          start: {
            line: 131,
            column: 42
          },
          end: {
            line: 131,
            column: 43
          }
        },
        loc: {
          start: {
            line: 131,
            column: 60
          },
          end: {
            line: 171,
            column: 5
          }
        },
        line: 131
      },
      "13": {
        name: "(anonymous_13)",
        decl: {
          start: {
            line: 136,
            column: 12
          },
          end: {
            line: 136,
            column: 13
          }
        },
        loc: {
          start: {
            line: 137,
            column: 14
          },
          end: {
            line: 137,
            column: 85
          }
        },
        line: 137
      },
      "14": {
        name: "(anonymous_14)",
        decl: {
          start: {
            line: 141,
            column: 12
          },
          end: {
            line: 141,
            column: 13
          }
        },
        loc: {
          start: {
            line: 142,
            column: 14
          },
          end: {
            line: 142,
            column: 94
          }
        },
        line: 142
      },
      "15": {
        name: "(anonymous_15)",
        decl: {
          start: {
            line: 151,
            column: 54
          },
          end: {
            line: 151,
            column: 55
          }
        },
        loc: {
          start: {
            line: 152,
            column: 10
          },
          end: {
            line: 152,
            column: 60
          }
        },
        line: 152
      },
      "16": {
        name: "(anonymous_16)",
        decl: {
          start: {
            line: 161,
            column: 60
          },
          end: {
            line: 161,
            column: 61
          }
        },
        loc: {
          start: {
            line: 162,
            column: 10
          },
          end: {
            line: 162,
            column: 67
          }
        },
        line: 162
      },
      "17": {
        name: "(anonymous_17)",
        decl: {
          start: {
            line: 172,
            column: 22
          },
          end: {
            line: 172,
            column: 23
          }
        },
        loc: {
          start: {
            line: 173,
            column: 6
          },
          end: {
            line: 173,
            column: 65
          }
        },
        line: 173
      },
      "18": {
        name: "(anonymous_18)",
        decl: {
          start: {
            line: 197,
            column: 7
          },
          end: {
            line: 197,
            column: 8
          }
        },
        loc: {
          start: {
            line: 197,
            column: 25
          },
          end: {
            line: 212,
            column: 3
          }
        },
        line: 197
      },
      "19": {
        name: "(anonymous_19)",
        decl: {
          start: {
            line: 208,
            column: 8
          },
          end: {
            line: 208,
            column: 9
          }
        },
        loc: {
          start: {
            line: 208,
            column: 19
          },
          end: {
            line: 208,
            column: 52
          }
        },
        line: 208
      },
      "20": {
        name: "(anonymous_20)",
        decl: {
          start: {
            line: 222,
            column: 18
          },
          end: {
            line: 222,
            column: 19
          }
        },
        loc: {
          start: {
            line: 223,
            column: 4
          },
          end: {
            line: 230,
            column: 6
          }
        },
        line: 223
      },
      "21": {
        name: "(anonymous_21)",
        decl: {
          start: {
            line: 223,
            column: 17
          },
          end: {
            line: 223,
            column: 18
          }
        },
        loc: {
          start: {
            line: 223,
            column: 28
          },
          end: {
            line: 230,
            column: 5
          }
        },
        line: 223
      },
      "22": {
        name: "(anonymous_22)",
        decl: {
          start: {
            line: 226,
            column: 44
          },
          end: {
            line: 226,
            column: 45
          }
        },
        loc: {
          start: {
            line: 227,
            column: 8
          },
          end: {
            line: 227,
            column: 71
          }
        },
        line: 227
      },
      "23": {
        name: "(anonymous_23)",
        decl: {
          start: {
            line: 240,
            column: 15
          },
          end: {
            line: 240,
            column: 16
          }
        },
        loc: {
          start: {
            line: 240,
            column: 53
          },
          end: {
            line: 270,
            column: 3
          }
        },
        line: 240
      },
      "24": {
        name: "(anonymous_24)",
        decl: {
          start: {
            line: 262,
            column: 44
          },
          end: {
            line: 262,
            column: 45
          }
        },
        loc: {
          start: {
            line: 262,
            column: 55
          },
          end: {
            line: 262,
            column: 68
          }
        },
        line: 262
      },
      "25": {
        name: "(anonymous_25)",
        decl: {
          start: {
            line: 279,
            column: 21
          },
          end: {
            line: 279,
            column: 22
          }
        },
        loc: {
          start: {
            line: 279,
            column: 47
          },
          end: {
            line: 306,
            column: 3
          }
        },
        line: 279
      },
      "26": {
        name: "(anonymous_26)",
        decl: {
          start: {
            line: 282,
            column: 25
          },
          end: {
            line: 282,
            column: 26
          }
        },
        loc: {
          start: {
            line: 282,
            column: 36
          },
          end: {
            line: 304,
            column: 5
          }
        },
        line: 282
      },
      "27": {
        name: "(anonymous_27)",
        decl: {
          start: {
            line: 283,
            column: 28
          },
          end: {
            line: 283,
            column: 29
          }
        },
        loc: {
          start: {
            line: 283,
            column: 36
          },
          end: {
            line: 303,
            column: 7
          }
        },
        line: 283
      },
      "28": {
        name: "(anonymous_28)",
        decl: {
          start: {
            line: 314,
            column: 19
          },
          end: {
            line: 314,
            column: 20
          }
        },
        loc: {
          start: {
            line: 314,
            column: 41
          },
          end: {
            line: 403,
            column: 3
          }
        },
        line: 314
      },
      "29": {
        name: "(anonymous_29)",
        decl: {
          start: {
            line: 317,
            column: 39
          },
          end: {
            line: 317,
            column: 40
          }
        },
        loc: {
          start: {
            line: 317,
            column: 50
          },
          end: {
            line: 317,
            column: 63
          }
        },
        line: 317
      },
      "30": {
        name: "(anonymous_30)",
        decl: {
          start: {
            line: 323,
            column: 20
          },
          end: {
            line: 323,
            column: 21
          }
        },
        loc: {
          start: {
            line: 323,
            column: 28
          },
          end: {
            line: 323,
            column: 71
          }
        },
        line: 323
      },
      "31": {
        name: "(anonymous_31)",
        decl: {
          start: {
            line: 324,
            column: 23
          },
          end: {
            line: 324,
            column: 24
          }
        },
        loc: {
          start: {
            line: 324,
            column: 31
          },
          end: {
            line: 324,
            column: 74
          }
        },
        line: 324
      },
      "32": {
        name: "(anonymous_32)",
        decl: {
          start: {
            line: 325,
            column: 28
          },
          end: {
            line: 325,
            column: 29
          }
        },
        loc: {
          start: {
            line: 325,
            column: 36
          },
          end: {
            line: 325,
            column: 79
          }
        },
        line: 325
      },
      "33": {
        name: "(anonymous_33)",
        decl: {
          start: {
            line: 326,
            column: 20
          },
          end: {
            line: 326,
            column: 21
          }
        },
        loc: {
          start: {
            line: 326,
            column: 28
          },
          end: {
            line: 326,
            column: 89
          }
        },
        line: 326
      },
      "34": {
        name: "(anonymous_34)",
        decl: {
          start: {
            line: 335,
            column: 18
          },
          end: {
            line: 335,
            column: 19
          }
        },
        loc: {
          start: {
            line: 335,
            column: 26
          },
          end: {
            line: 360,
            column: 5
          }
        },
        line: 335
      },
      "35": {
        name: "(anonymous_35)",
        decl: {
          start: {
            line: 341,
            column: 56
          },
          end: {
            line: 341,
            column: 57
          }
        },
        loc: {
          start: {
            line: 341,
            column: 63
          },
          end: {
            line: 354,
            column: 7
          }
        },
        line: 341
      },
      "36": {
        name: "(anonymous_36)",
        decl: {
          start: {
            line: 367,
            column: 13
          },
          end: {
            line: 367,
            column: 14
          }
        },
        loc: {
          start: {
            line: 367,
            column: 19
          },
          end: {
            line: 367,
            column: 24
          }
        },
        line: 367
      },
      "37": {
        name: "(anonymous_37)",
        decl: {
          start: {
            line: 370,
            column: 60
          },
          end: {
            line: 370,
            column: 61
          }
        },
        loc: {
          start: {
            line: 370,
            column: 67
          },
          end: {
            line: 400,
            column: 5
          }
        },
        line: 370
      },
      "38": {
        name: "(anonymous_38)",
        decl: {
          start: {
            line: 375,
            column: 25
          },
          end: {
            line: 375,
            column: 26
          }
        },
        loc: {
          start: {
            line: 375,
            column: 32
          },
          end: {
            line: 375,
            column: 52
          }
        },
        line: 375
      },
      "39": {
        name: "(anonymous_39)",
        decl: {
          start: {
            line: 376,
            column: 44
          },
          end: {
            line: 376,
            column: 45
          }
        },
        loc: {
          start: {
            line: 376,
            column: 52
          },
          end: {
            line: 392,
            column: 7
          }
        },
        line: 376
      },
      "40": {
        name: "(anonymous_40)",
        decl: {
          start: {
            line: 381,
            column: 25
          },
          end: {
            line: 381,
            column: 26
          }
        },
        loc: {
          start: {
            line: 381,
            column: 32
          },
          end: {
            line: 381,
            column: 65
          }
        },
        line: 381
      },
      "41": {
        name: "(anonymous_41)",
        decl: {
          start: {
            line: 410,
            column: 18
          },
          end: {
            line: 410,
            column: 19
          }
        },
        loc: {
          start: {
            line: 410,
            column: 40
          },
          end: {
            line: 465,
            column: 3
          }
        },
        line: 410
      },
      "42": {
        name: "(anonymous_42)",
        decl: {
          start: {
            line: 419,
            column: 21
          },
          end: {
            line: 419,
            column: 22
          }
        },
        loc: {
          start: {
            line: 419,
            column: 32
          },
          end: {
            line: 463,
            column: 5
          }
        },
        line: 419
      },
      "43": {
        name: "(anonymous_43)",
        decl: {
          start: {
            line: 420,
            column: 28
          },
          end: {
            line: 420,
            column: 29
          }
        },
        loc: {
          start: {
            line: 420,
            column: 43
          },
          end: {
            line: 462,
            column: 7
          }
        },
        line: 420
      },
      "44": {
        name: "(anonymous_44)",
        decl: {
          start: {
            line: 427,
            column: 28
          },
          end: {
            line: 427,
            column: 29
          }
        },
        loc: {
          start: {
            line: 427,
            column: 35
          },
          end: {
            line: 461,
            column: 9
          }
        },
        line: 427
      },
      "45": {
        name: "(anonymous_45)",
        decl: {
          start: {
            line: 474,
            column: 16
          },
          end: {
            line: 474,
            column: 17
          }
        },
        loc: {
          start: {
            line: 474,
            column: 51
          },
          end: {
            line: 512,
            column: 3
          }
        },
        line: 474
      },
      "46": {
        name: "(anonymous_46)",
        decl: {
          start: {
            line: 495,
            column: 53
          },
          end: {
            line: 495,
            column: 54
          }
        },
        loc: {
          start: {
            line: 495,
            column: 77
          },
          end: {
            line: 504,
            column: 5
          }
        },
        line: 495
      },
      "47": {
        name: "(anonymous_47)",
        decl: {
          start: {
            line: 501,
            column: 32
          },
          end: {
            line: 501,
            column: 33
          }
        },
        loc: {
          start: {
            line: 501,
            column: 37
          },
          end: {
            line: 501,
            column: 92
          }
        },
        line: 501
      },
      "48": {
        name: "(anonymous_48)",
        decl: {
          start: {
            line: 521,
            column: 18
          },
          end: {
            line: 521,
            column: 19
          }
        },
        loc: {
          start: {
            line: 521,
            column: 57
          },
          end: {
            line: 545,
            column: 3
          }
        },
        line: 521
      },
      "49": {
        name: "(anonymous_49)",
        decl: {
          start: {
            line: 525,
            column: 17
          },
          end: {
            line: 525,
            column: 18
          }
        },
        loc: {
          start: {
            line: 526,
            column: 6
          },
          end: {
            line: 530,
            column: 8
          }
        },
        line: 526
      },
      "50": {
        name: "(anonymous_50)",
        decl: {
          start: {
            line: 526,
            column: 35
          },
          end: {
            line: 526,
            column: 36
          }
        },
        loc: {
          start: {
            line: 526,
            column: 50
          },
          end: {
            line: 530,
            column: 7
          }
        },
        line: 526
      },
      "51": {
        name: "(anonymous_51)",
        decl: {
          start: {
            line: 533,
            column: 25
          },
          end: {
            line: 533,
            column: 26
          }
        },
        loc: {
          start: {
            line: 533,
            column: 36
          },
          end: {
            line: 542,
            column: 5
          }
        },
        line: 533
      },
      "52": {
        name: "(anonymous_52)",
        decl: {
          start: {
            line: 534,
            column: 35
          },
          end: {
            line: 534,
            column: 36
          }
        },
        loc: {
          start: {
            line: 534,
            column: 41
          },
          end: {
            line: 541,
            column: 7
          }
        },
        line: 534
      },
      "53": {
        name: "(anonymous_53)",
        decl: {
          start: {
            line: 549,
            column: 17
          },
          end: {
            line: 549,
            column: 18
          }
        },
        loc: {
          start: {
            line: 549,
            column: 47
          },
          end: {
            line: 556,
            column: 3
          }
        },
        line: 549
      },
      "54": {
        name: "(anonymous_54)",
        decl: {
          start: {
            line: 552,
            column: 39
          },
          end: {
            line: 552,
            column: 40
          }
        },
        loc: {
          start: {
            line: 552,
            column: 50
          },
          end: {
            line: 552,
            column: 66
          }
        },
        line: 552
      },
      "55": {
        name: "(anonymous_55)",
        decl: {
          start: {
            line: 563,
            column: 27
          },
          end: {
            line: 563,
            column: 28
          }
        },
        loc: {
          start: {
            line: 563,
            column: 73
          },
          end: {
            line: 583,
            column: 3
          }
        },
        line: 563
      },
      "56": {
        name: "(anonymous_56)",
        decl: {
          start: {
            line: 564,
            column: 41
          },
          end: {
            line: 564,
            column: 42
          }
        },
        loc: {
          start: {
            line: 564,
            column: 53
          },
          end: {
            line: 567,
            column: 5
          }
        },
        line: 564
      },
      "57": {
        name: "(anonymous_57)",
        decl: {
          start: {
            line: 569,
            column: 42
          },
          end: {
            line: 569,
            column: 43
          }
        },
        loc: {
          start: {
            line: 569,
            column: 54
          },
          end: {
            line: 572,
            column: 5
          }
        },
        line: 569
      },
      "58": {
        name: "(anonymous_58)",
        decl: {
          start: {
            line: 593,
            column: 25
          },
          end: {
            line: 593,
            column: 26
          }
        },
        loc: {
          start: {
            line: 593,
            column: 60
          },
          end: {
            line: 632,
            column: 3
          }
        },
        line: 593
      },
      "59": {
        name: "(anonymous_59)",
        decl: {
          start: {
            line: 613,
            column: 38
          },
          end: {
            line: 613,
            column: 39
          }
        },
        loc: {
          start: {
            line: 613,
            column: 47
          },
          end: {
            line: 616,
            column: 5
          }
        },
        line: 613
      },
      "60": {
        name: "(anonymous_60)",
        decl: {
          start: {
            line: 654,
            column: 25
          },
          end: {
            line: 654,
            column: 26
          }
        },
        loc: {
          start: {
            line: 654,
            column: 46
          },
          end: {
            line: 725,
            column: 3
          }
        },
        line: 654
      },
      "61": {
        name: "(anonymous_61)",
        decl: {
          start: {
            line: 665,
            column: 54
          },
          end: {
            line: 665,
            column: 55
          }
        },
        loc: {
          start: {
            line: 666,
            column: 6
          },
          end: {
            line: 666,
            column: 54
          }
        },
        line: 666
      },
      "62": {
        name: "(anonymous_62)",
        decl: {
          start: {
            line: 670,
            column: 49
          },
          end: {
            line: 670,
            column: 50
          }
        },
        loc: {
          start: {
            line: 670,
            column: 63
          },
          end: {
            line: 722,
            column: 5
          }
        },
        line: 670
      },
      "63": {
        name: "(anonymous_63)",
        decl: {
          start: {
            line: 702,
            column: 33
          },
          end: {
            line: 702,
            column: 34
          }
        },
        loc: {
          start: {
            line: 702,
            column: 54
          },
          end: {
            line: 705,
            column: 7
          }
        },
        line: 702
      },
      "64": {
        name: "(anonymous_64)",
        decl: {
          start: {
            line: 730,
            column: 14
          },
          end: {
            line: 730,
            column: 15
          }
        },
        loc: {
          start: {
            line: 731,
            column: 4
          },
          end: {
            line: 734,
            column: 66
          }
        },
        line: 731
      },
      "65": {
        name: "(anonymous_65)",
        decl: {
          start: {
            line: 734,
            column: 26
          },
          end: {
            line: 734,
            column: 27
          }
        },
        loc: {
          start: {
            line: 734,
            column: 37
          },
          end: {
            line: 734,
            column: 65
          }
        },
        line: 734
      },
      "66": {
        name: "(anonymous_66)",
        decl: {
          start: {
            line: 737,
            column: 11
          },
          end: {
            line: 737,
            column: 12
          }
        },
        loc: {
          start: {
            line: 737,
            column: 22
          },
          end: {
            line: 737,
            column: 34
          }
        },
        line: 737
      },
      "67": {
        name: "(anonymous_67)",
        decl: {
          start: {
            line: 739,
            column: 26
          },
          end: {
            line: 739,
            column: 27
          }
        },
        loc: {
          start: {
            line: 739,
            column: 77
          },
          end: {
            line: 761,
            column: 3
          }
        },
        line: 739
      },
      "68": {
        name: "(anonymous_68)",
        decl: {
          start: {
            line: 752,
            column: 44
          },
          end: {
            line: 752,
            column: 45
          }
        },
        loc: {
          start: {
            line: 752,
            column: 57
          },
          end: {
            line: 752,
            column: 88
          }
        },
        line: 752
      },
      "69": {
        name: "(anonymous_69)",
        decl: {
          start: {
            line: 766,
            column: 18
          },
          end: {
            line: 766,
            column: 19
          }
        },
        loc: {
          start: {
            line: 767,
            column: 4
          },
          end: {
            line: 775,
            column: 5
          }
        },
        line: 767
      },
      "70": {
        name: "(anonymous_70)",
        decl: {
          start: {
            line: 768,
            column: 27
          },
          end: {
            line: 768,
            column: 28
          }
        },
        loc: {
          start: {
            line: 768,
            column: 38
          },
          end: {
            line: 774,
            column: 7
          }
        },
        line: 768
      },
      "71": {
        name: "(anonymous_71)",
        decl: {
          start: {
            line: 769,
            column: 50
          },
          end: {
            line: 769,
            column: 51
          }
        },
        loc: {
          start: {
            line: 769,
            column: 58
          },
          end: {
            line: 769,
            column: 70
          }
        },
        line: 769
      },
      "72": {
        name: "(anonymous_72)",
        decl: {
          start: {
            line: 771,
            column: 40
          },
          end: {
            line: 771,
            column: 41
          }
        },
        loc: {
          start: {
            line: 771,
            column: 51
          },
          end: {
            line: 771,
            column: 91
          }
        },
        line: 771
      },
      "73": {
        name: "(anonymous_73)",
        decl: {
          start: {
            line: 780,
            column: 21
          },
          end: {
            line: 780,
            column: 22
          }
        },
        loc: {
          start: {
            line: 781,
            column: 4
          },
          end: {
            line: 785,
            column: 5
          }
        },
        line: 781
      },
      "74": {
        name: "(anonymous_74)",
        decl: {
          start: {
            line: 783,
            column: 16
          },
          end: {
            line: 783,
            column: 17
          }
        },
        loc: {
          start: {
            line: 783,
            column: 27
          },
          end: {
            line: 783,
            column: 111
          }
        },
        line: 783
      },
      "75": {
        name: "(anonymous_75)",
        decl: {
          start: {
            line: 784,
            column: 13
          },
          end: {
            line: 784,
            column: 14
          }
        },
        loc: {
          start: {
            line: 784,
            column: 24
          },
          end: {
            line: 784,
            column: 86
          }
        },
        line: 784
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 15,
            column: 2
          },
          end: {
            line: 17,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 15,
            column: 2
          },
          end: {
            line: 17,
            column: 3
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 15
      },
      "1": {
        loc: {
          start: {
            line: 15,
            column: 6
          },
          end: {
            line: 15,
            column: 46
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 15,
            column: 6
          },
          end: {
            line: 15,
            column: 14
          }
        }, {
          start: {
            line: 15,
            column: 18
          },
          end: {
            line: 15,
            column: 46
          }
        }],
        line: 15
      },
      "2": {
        loc: {
          start: {
            line: 20,
            column: 4
          },
          end: {
            line: 22,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 20,
            column: 4
          },
          end: {
            line: 22,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 20
      },
      "3": {
        loc: {
          start: {
            line: 36,
            column: 2
          },
          end: {
            line: 38,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 36,
            column: 2
          },
          end: {
            line: 38,
            column: 3
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 36
      },
      "4": {
        loc: {
          start: {
            line: 36,
            column: 6
          },
          end: {
            line: 36,
            column: 61
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 36,
            column: 6
          },
          end: {
            line: 36,
            column: 40
          }
        }, {
          start: {
            line: 36,
            column: 44
          },
          end: {
            line: 36,
            column: 61
          }
        }],
        line: 36
      },
      "5": {
        loc: {
          start: {
            line: 90,
            column: 12
          },
          end: {
            line: 90,
            column: 76
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 90,
            column: 12
          },
          end: {
            line: 90,
            column: 21
          }
        }, {
          start: {
            line: 90,
            column: 26
          },
          end: {
            line: 90,
            column: 45
          }
        }, {
          start: {
            line: 90,
            column: 49
          },
          end: {
            line: 90,
            column: 75
          }
        }],
        line: 90
      },
      "6": {
        loc: {
          start: {
            line: 92,
            column: 4
          },
          end: {
            line: 94,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 92,
            column: 4
          },
          end: {
            line: 94,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 92
      },
      "7": {
        loc: {
          start: {
            line: 92,
            column: 8
          },
          end: {
            line: 92,
            column: 43
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 92,
            column: 8
          },
          end: {
            line: 92,
            column: 18
          }
        }, {
          start: {
            line: 92,
            column: 22
          },
          end: {
            line: 92,
            column: 43
          }
        }],
        line: 92
      },
      "8": {
        loc: {
          start: {
            line: 107,
            column: 12
          },
          end: {
            line: 107,
            column: 94
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 107,
            column: 12
          },
          end: {
            line: 107,
            column: 27
          }
        }, {
          start: {
            line: 107,
            column: 32
          },
          end: {
            line: 107,
            column: 57
          }
        }, {
          start: {
            line: 107,
            column: 61
          },
          end: {
            line: 107,
            column: 93
          }
        }],
        line: 107
      },
      "9": {
        loc: {
          start: {
            line: 109,
            column: 4
          },
          end: {
            line: 113,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 109,
            column: 4
          },
          end: {
            line: 113,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 109
      },
      "10": {
        loc: {
          start: {
            line: 109,
            column: 8
          },
          end: {
            line: 109,
            column: 49
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 109,
            column: 8
          },
          end: {
            line: 109,
            column: 21
          }
        }, {
          start: {
            line: 109,
            column: 25
          },
          end: {
            line: 109,
            column: 49
          }
        }],
        line: 109
      },
      "11": {
        loc: {
          start: {
            line: 133,
            column: 6
          },
          end: {
            line: 170,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 133,
            column: 6
          },
          end: {
            line: 170,
            column: 7
          }
        }, {
          start: {
            line: 149,
            column: 13
          },
          end: {
            line: 170,
            column: 7
          }
        }],
        line: 133
      },
      "12": {
        loc: {
          start: {
            line: 137,
            column: 25
          },
          end: {
            line: 137,
            column: 52
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 137,
            column: 25
          },
          end: {
            line: 137,
            column: 46
          }
        }, {
          start: {
            line: 137,
            column: 50
          },
          end: {
            line: 137,
            column: 52
          }
        }],
        line: 137
      },
      "13": {
        loc: {
          start: {
            line: 137,
            column: 54
          },
          end: {
            line: 137,
            column: 84
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 137,
            column: 54
          },
          end: {
            line: 137,
            column: 78
          }
        }, {
          start: {
            line: 137,
            column: 82
          },
          end: {
            line: 137,
            column: 84
          }
        }],
        line: 137
      },
      "14": {
        loc: {
          start: {
            line: 142,
            column: 52
          },
          end: {
            line: 142,
            column: 93
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 142,
            column: 52
          },
          end: {
            line: 142,
            column: 65
          }
        }, {
          start: {
            line: 142,
            column: 69
          },
          end: {
            line: 142,
            column: 93
          }
        }],
        line: 142
      },
      "15": {
        loc: {
          start: {
            line: 149,
            column: 13
          },
          end: {
            line: 170,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 149,
            column: 13
          },
          end: {
            line: 170,
            column: 7
          }
        }, {
          start: {
            line: 159,
            column: 13
          },
          end: {
            line: 170,
            column: 7
          }
        }],
        line: 149
      },
      "16": {
        loc: {
          start: {
            line: 149,
            column: 17
          },
          end: {
            line: 149,
            column: 87
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 149,
            column: 17
          },
          end: {
            line: 149,
            column: 52
          }
        }, {
          start: {
            line: 149,
            column: 56
          },
          end: {
            line: 149,
            column: 87
          }
        }],
        line: 149
      },
      "17": {
        loc: {
          start: {
            line: 156,
            column: 21
          },
          end: {
            line: 156,
            column: 71
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 156,
            column: 46
          },
          end: {
            line: 156,
            column: 59
          }
        }, {
          start: {
            line: 156,
            column: 62
          },
          end: {
            line: 156,
            column: 71
          }
        }],
        line: 156
      },
      "18": {
        loc: {
          start: {
            line: 159,
            column: 13
          },
          end: {
            line: 170,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 159,
            column: 13
          },
          end: {
            line: 170,
            column: 7
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 159
      },
      "19": {
        loc: {
          start: {
            line: 159,
            column: 17
          },
          end: {
            line: 159,
            column: 93
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 159,
            column: 17
          },
          end: {
            line: 159,
            column: 55
          }
        }, {
          start: {
            line: 159,
            column: 59
          },
          end: {
            line: 159,
            column: 93
          }
        }],
        line: 159
      },
      "20": {
        loc: {
          start: {
            line: 167,
            column: 21
          },
          end: {
            line: 167,
            column: 74
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 167,
            column: 49
          },
          end: {
            line: 167,
            column: 62
          }
        }, {
          start: {
            line: 167,
            column: 65
          },
          end: {
            line: 167,
            column: 74
          }
        }],
        line: 167
      },
      "21": {
        loc: {
          start: {
            line: 202,
            column: 12
          },
          end: {
            line: 202,
            column: 76
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 202,
            column: 12
          },
          end: {
            line: 202,
            column: 21
          }
        }, {
          start: {
            line: 202,
            column: 26
          },
          end: {
            line: 202,
            column: 45
          }
        }, {
          start: {
            line: 202,
            column: 49
          },
          end: {
            line: 202,
            column: 75
          }
        }],
        line: 202
      },
      "22": {
        loc: {
          start: {
            line: 204,
            column: 4
          },
          end: {
            line: 210,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 204,
            column: 4
          },
          end: {
            line: 210,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 204
      },
      "23": {
        loc: {
          start: {
            line: 204,
            column: 8
          },
          end: {
            line: 204,
            column: 49
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 204,
            column: 8
          },
          end: {
            line: 204,
            column: 21
          }
        }, {
          start: {
            line: 204,
            column: 25
          },
          end: {
            line: 204,
            column: 49
          }
        }],
        line: 204
      },
      "24": {
        loc: {
          start: {
            line: 225,
            column: 20
          },
          end: {
            line: 225,
            column: 79
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 225,
            column: 20
          },
          end: {
            line: 225,
            column: 44
          }
        }, {
          start: {
            line: 225,
            column: 48
          },
          end: {
            line: 225,
            column: 79
          }
        }],
        line: 225
      },
      "25": {
        loc: {
          start: {
            line: 244,
            column: 4
          },
          end: {
            line: 269,
            column: 5
          }
        },
        type: "switch",
        locations: [{
          start: {
            line: 246,
            column: 6
          },
          end: {
            line: 247,
            column: 68
          }
        }, {
          start: {
            line: 249,
            column: 6
          },
          end: {
            line: 250,
            column: 66
          }
        }, {
          start: {
            line: 252,
            column: 6
          },
          end: {
            line: 253,
            column: 65
          }
        }, {
          start: {
            line: 255,
            column: 6
          },
          end: {
            line: 264,
            column: 10
          }
        }, {
          start: {
            line: 266,
            column: 6
          },
          end: {
            line: 266,
            column: 21
          }
        }, {
          start: {
            line: 267,
            column: 6
          },
          end: {
            line: 268,
            column: 28
          }
        }],
        line: 244
      },
      "26": {
        loc: {
          start: {
            line: 287,
            column: 8
          },
          end: {
            line: 289,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 287,
            column: 8
          },
          end: {
            line: 289,
            column: 9
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 287
      },
      "27": {
        loc: {
          start: {
            line: 291,
            column: 8
          },
          end: {
            line: 293,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 291,
            column: 8
          },
          end: {
            line: 293,
            column: 9
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 291
      },
      "28": {
        loc: {
          start: {
            line: 297,
            column: 26
          },
          end: {
            line: 300,
            column: 9
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 297,
            column: 26
          },
          end: {
            line: 297,
            column: 41
          }
        }, {
          start: {
            line: 297,
            column: 45
          },
          end: {
            line: 300,
            column: 9
          }
        }],
        line: 297
      },
      "29": {
        loc: {
          start: {
            line: 316,
            column: 27
          },
          end: {
            line: 316,
            column: 58
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 316,
            column: 27
          },
          end: {
            line: 316,
            column: 47
          }
        }, {
          start: {
            line: 316,
            column: 51
          },
          end: {
            line: 316,
            column: 58
          }
        }],
        line: 316
      },
      "30": {
        loc: {
          start: {
            line: 326,
            column: 28
          },
          end: {
            line: 326,
            column: 89
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 326,
            column: 28
          },
          end: {
            line: 326,
            column: 42
          }
        }, {
          start: {
            line: 326,
            column: 46
          },
          end: {
            line: 326,
            column: 63
          }
        }, {
          start: {
            line: 326,
            column: 67
          },
          end: {
            line: 326,
            column: 89
          }
        }],
        line: 326
      },
      "31": {
        loc: {
          start: {
            line: 342,
            column: 8
          },
          end: {
            line: 345,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 342,
            column: 8
          },
          end: {
            line: 345,
            column: 9
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 342
      },
      "32": {
        loc: {
          start: {
            line: 342,
            column: 12
          },
          end: {
            line: 342,
            column: 57
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 342,
            column: 12
          },
          end: {
            line: 342,
            column: 21
          }
        }, {
          start: {
            line: 342,
            column: 25
          },
          end: {
            line: 342,
            column: 57
          }
        }],
        line: 342
      },
      "33": {
        loc: {
          start: {
            line: 346,
            column: 8
          },
          end: {
            line: 349,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 346,
            column: 8
          },
          end: {
            line: 349,
            column: 9
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 346
      },
      "34": {
        loc: {
          start: {
            line: 346,
            column: 12
          },
          end: {
            line: 346,
            column: 63
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 346,
            column: 12
          },
          end: {
            line: 346,
            column: 24
          }
        }, {
          start: {
            line: 346,
            column: 28
          },
          end: {
            line: 346,
            column: 63
          }
        }],
        line: 346
      },
      "35": {
        loc: {
          start: {
            line: 350,
            column: 8
          },
          end: {
            line: 353,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 350,
            column: 8
          },
          end: {
            line: 353,
            column: 9
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 350
      },
      "36": {
        loc: {
          start: {
            line: 350,
            column: 12
          },
          end: {
            line: 350,
            column: 73
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 350,
            column: 12
          },
          end: {
            line: 350,
            column: 29
          }
        }, {
          start: {
            line: 350,
            column: 33
          },
          end: {
            line: 350,
            column: 73
          }
        }],
        line: 350
      },
      "37": {
        loc: {
          start: {
            line: 355,
            column: 23
          },
          end: {
            line: 355,
            column: 60
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 355,
            column: 23
          },
          end: {
            line: 355,
            column: 35
          }
        }, {
          start: {
            line: 355,
            column: 39
          },
          end: {
            line: 355,
            column: 60
          }
        }],
        line: 355
      },
      "38": {
        loc: {
          start: {
            line: 357,
            column: 6
          },
          end: {
            line: 359,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 357,
            column: 6
          },
          end: {
            line: 359,
            column: 7
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 357
      },
      "39": {
        loc: {
          start: {
            line: 357,
            column: 10
          },
          end: {
            line: 357,
            column: 53
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 357,
            column: 10
          },
          end: {
            line: 357,
            column: 18
          }
        }, {
          start: {
            line: 357,
            column: 22
          },
          end: {
            line: 357,
            column: 53
          }
        }],
        line: 357
      },
      "40": {
        loc: {
          start: {
            line: 371,
            column: 6
          },
          end: {
            line: 373,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 371,
            column: 6
          },
          end: {
            line: 373,
            column: 7
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 371
      },
      "41": {
        loc: {
          start: {
            line: 375,
            column: 32
          },
          end: {
            line: 375,
            column: 52
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 375,
            column: 32
          },
          end: {
            line: 375,
            column: 35
          }
        }, {
          start: {
            line: 375,
            column: 39
          },
          end: {
            line: 375,
            column: 52
          }
        }],
        line: 375
      },
      "42": {
        loc: {
          start: {
            line: 382,
            column: 8
          },
          end: {
            line: 384,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 382,
            column: 8
          },
          end: {
            line: 384,
            column: 9
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 382
      },
      "43": {
        loc: {
          start: {
            line: 385,
            column: 8
          },
          end: {
            line: 387,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 385,
            column: 8
          },
          end: {
            line: 387,
            column: 9
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 385
      },
      "44": {
        loc: {
          start: {
            line: 388,
            column: 8
          },
          end: {
            line: 390,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 388,
            column: 8
          },
          end: {
            line: 390,
            column: 9
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 388
      },
      "45": {
        loc: {
          start: {
            line: 423,
            column: 8
          },
          end: {
            line: 425,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 423,
            column: 8
          },
          end: {
            line: 425,
            column: 9
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 423
      },
      "46": {
        loc: {
          start: {
            line: 423,
            column: 12
          },
          end: {
            line: 423,
            column: 52
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 423,
            column: 12
          },
          end: {
            line: 423,
            column: 24
          }
        }, {
          start: {
            line: 423,
            column: 28
          },
          end: {
            line: 423,
            column: 52
          }
        }],
        line: 423
      },
      "47": {
        loc: {
          start: {
            line: 432,
            column: 10
          },
          end: {
            line: 460,
            column: 11
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 432,
            column: 10
          },
          end: {
            line: 460,
            column: 11
          }
        }, {
          start: {
            line: 457,
            column: 17
          },
          end: {
            line: 460,
            column: 11
          }
        }],
        line: 432
      },
      "48": {
        loc: {
          start: {
            line: 436,
            column: 30
          },
          end: {
            line: 436,
            column: 52
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 436,
            column: 40
          },
          end: {
            line: 436,
            column: 45
          }
        }, {
          start: {
            line: 436,
            column: 48
          },
          end: {
            line: 436,
            column: 52
          }
        }],
        line: 436
      },
      "49": {
        loc: {
          start: {
            line: 437,
            column: 27
          },
          end: {
            line: 437,
            column: 49
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 437,
            column: 37
          },
          end: {
            line: 437,
            column: 41
          }
        }, {
          start: {
            line: 437,
            column: 44
          },
          end: {
            line: 437,
            column: 49
          }
        }],
        line: 437
      },
      "50": {
        loc: {
          start: {
            line: 442,
            column: 12
          },
          end: {
            line: 456,
            column: 13
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 442,
            column: 12
          },
          end: {
            line: 456,
            column: 13
          }
        }, {
          start: {
            line: 445,
            column: 19
          },
          end: {
            line: 456,
            column: 13
          }
        }],
        line: 442
      },
      "51": {
        loc: {
          start: {
            line: 459,
            column: 13
          },
          end: {
            line: 459,
            column: 84
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 459,
            column: 13
          },
          end: {
            line: 459,
            column: 48
          }
        }, {
          start: {
            line: 459,
            column: 52
          },
          end: {
            line: 459,
            column: 84
          }
        }],
        line: 459
      },
      "52": {
        loc: {
          start: {
            line: 550,
            column: 4
          },
          end: {
            line: 554,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 550,
            column: 4
          },
          end: {
            line: 554,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 550
      },
      "53": {
        loc: {
          start: {
            line: 550,
            column: 8
          },
          end: {
            line: 550,
            column: 39
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 550,
            column: 8
          },
          end: {
            line: 550,
            column: 16
          }
        }, {
          start: {
            line: 550,
            column: 20
          },
          end: {
            line: 550,
            column: 39
          }
        }],
        line: 550
      },
      "54": {
        loc: {
          start: {
            line: 551,
            column: 31
          },
          end: {
            line: 551,
            column: 60
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 551,
            column: 31
          },
          end: {
            line: 551,
            column: 45
          }
        }, {
          start: {
            line: 551,
            column: 49
          },
          end: {
            line: 551,
            column: 60
          }
        }],
        line: 551
      },
      "55": {
        loc: {
          start: {
            line: 598,
            column: 21
          },
          end: {
            line: 598,
            column: 61
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 598,
            column: 35
          },
          end: {
            line: 598,
            column: 56
          }
        }, {
          start: {
            line: 598,
            column: 59
          },
          end: {
            line: 598,
            column: 61
          }
        }],
        line: 598
      },
      "56": {
        loc: {
          start: {
            line: 599,
            column: 28
          },
          end: {
            line: 599,
            column: 75
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 599,
            column: 42
          },
          end: {
            line: 599,
            column: 70
          }
        }, {
          start: {
            line: 599,
            column: 73
          },
          end: {
            line: 599,
            column: 75
          }
        }],
        line: 599
      },
      "57": {
        loc: {
          start: {
            line: 605,
            column: 21
          },
          end: {
            line: 605,
            column: 55
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 605,
            column: 21
          },
          end: {
            line: 605,
            column: 35
          }
        }, {
          start: {
            line: 605,
            column: 39
          },
          end: {
            line: 605,
            column: 55
          }
        }],
        line: 605
      },
      "58": {
        loc: {
          start: {
            line: 678,
            column: 6
          },
          end: {
            line: 694,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 678,
            column: 6
          },
          end: {
            line: 694,
            column: 7
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 678
      },
      "59": {
        loc: {
          start: {
            line: 704,
            column: 27
          },
          end: {
            line: 704,
            column: 82
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 704,
            column: 27
          },
          end: {
            line: 704,
            column: 58
          }
        }, {
          start: {
            line: 704,
            column: 62
          },
          end: {
            line: 704,
            column: 82
          }
        }],
        line: 704
      },
      "60": {
        loc: {
          start: {
            line: 715,
            column: 23
          },
          end: {
            line: 717,
            column: 19
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 716,
            column: 10
          },
          end: {
            line: 716,
            column: 49
          }
        }, {
          start: {
            line: 717,
            column: 10
          },
          end: {
            line: 717,
            column: 19
          }
        }],
        line: 715
      },
      "61": {
        loc: {
          start: {
            line: 731,
            column: 4
          },
          end: {
            line: 734,
            column: 66
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 731,
            column: 4
          },
          end: {
            line: 731,
            column: 11
          }
        }, {
          start: {
            line: 732,
            column: 4
          },
          end: {
            line: 732,
            column: 20
          }
        }, {
          start: {
            line: 733,
            column: 4
          },
          end: {
            line: 733,
            column: 25
          }
        }, {
          start: {
            line: 734,
            column: 4
          },
          end: {
            line: 734,
            column: 66
          }
        }],
        line: 731
      },
      "62": {
        loc: {
          start: {
            line: 740,
            column: 4
          },
          end: {
            line: 742,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 740,
            column: 4
          },
          end: {
            line: 742,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 740
      },
      "63": {
        loc: {
          start: {
            line: 743,
            column: 29
          },
          end: {
            line: 743,
            column: 66
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 743,
            column: 29
          },
          end: {
            line: 743,
            column: 53
          }
        }, {
          start: {
            line: 743,
            column: 57
          },
          end: {
            line: 743,
            column: 66
          }
        }],
        line: 743
      },
      "64": {
        loc: {
          start: {
            line: 745,
            column: 4
          },
          end: {
            line: 755,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 745,
            column: 4
          },
          end: {
            line: 755,
            column: 5
          }
        }, {
          start: {
            line: 751,
            column: 11
          },
          end: {
            line: 755,
            column: 5
          }
        }],
        line: 745
      },
      "65": {
        loc: {
          start: {
            line: 746,
            column: 6
          },
          end: {
            line: 750,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 746,
            column: 6
          },
          end: {
            line: 750,
            column: 7
          }
        }, {
          start: {
            line: 748,
            column: 13
          },
          end: {
            line: 750,
            column: 7
          }
        }],
        line: 746
      },
      "66": {
        loc: {
          start: {
            line: 751,
            column: 11
          },
          end: {
            line: 755,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 751,
            column: 11
          },
          end: {
            line: 755,
            column: 5
          }
        }, {
          start: {
            line: 753,
            column: 11
          },
          end: {
            line: 755,
            column: 5
          }
        }],
        line: 751
      },
      "67": {
        loc: {
          start: {
            line: 770,
            column: 8
          },
          end: {
            line: 772,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 770,
            column: 8
          },
          end: {
            line: 772,
            column: 9
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 770
      },
      "68": {
        loc: {
          start: {
            line: 771,
            column: 51
          },
          end: {
            line: 771,
            column: 91
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 771,
            column: 51
          },
          end: {
            line: 771,
            column: 61
          }
        }, {
          start: {
            line: 771,
            column: 65
          },
          end: {
            line: 771,
            column: 91
          }
        }],
        line: 771
      },
      "69": {
        loc: {
          start: {
            line: 783,
            column: 27
          },
          end: {
            line: 783,
            column: 111
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 783,
            column: 28
          },
          end: {
            line: 783,
            column: 40
          }
        }, {
          start: {
            line: 783,
            column: 44
          },
          end: {
            line: 783,
            column: 72
          }
        }, {
          start: {
            line: 783,
            column: 77
          },
          end: {
            line: 783,
            column: 111
          }
        }],
        line: 783
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0,
      "41": 0,
      "42": 0,
      "43": 0,
      "44": 0,
      "45": 0,
      "46": 0,
      "47": 0,
      "48": 0,
      "49": 0,
      "50": 0,
      "51": 0,
      "52": 0,
      "53": 0,
      "54": 0,
      "55": 0,
      "56": 0,
      "57": 0,
      "58": 0,
      "59": 0,
      "60": 0,
      "61": 0,
      "62": 0,
      "63": 0,
      "64": 0,
      "65": 0,
      "66": 0,
      "67": 0,
      "68": 0,
      "69": 0,
      "70": 0,
      "71": 0,
      "72": 0,
      "73": 0,
      "74": 0,
      "75": 0,
      "76": 0,
      "77": 0,
      "78": 0,
      "79": 0,
      "80": 0,
      "81": 0,
      "82": 0,
      "83": 0,
      "84": 0,
      "85": 0,
      "86": 0,
      "87": 0,
      "88": 0,
      "89": 0,
      "90": 0,
      "91": 0,
      "92": 0,
      "93": 0,
      "94": 0,
      "95": 0,
      "96": 0,
      "97": 0,
      "98": 0,
      "99": 0,
      "100": 0,
      "101": 0,
      "102": 0,
      "103": 0,
      "104": 0,
      "105": 0,
      "106": 0,
      "107": 0,
      "108": 0,
      "109": 0,
      "110": 0,
      "111": 0,
      "112": 0,
      "113": 0,
      "114": 0,
      "115": 0,
      "116": 0,
      "117": 0,
      "118": 0,
      "119": 0,
      "120": 0,
      "121": 0,
      "122": 0,
      "123": 0,
      "124": 0,
      "125": 0,
      "126": 0,
      "127": 0,
      "128": 0,
      "129": 0,
      "130": 0,
      "131": 0,
      "132": 0,
      "133": 0,
      "134": 0,
      "135": 0,
      "136": 0,
      "137": 0,
      "138": 0,
      "139": 0,
      "140": 0,
      "141": 0,
      "142": 0,
      "143": 0,
      "144": 0,
      "145": 0,
      "146": 0,
      "147": 0,
      "148": 0,
      "149": 0,
      "150": 0,
      "151": 0,
      "152": 0,
      "153": 0,
      "154": 0,
      "155": 0,
      "156": 0,
      "157": 0,
      "158": 0,
      "159": 0,
      "160": 0,
      "161": 0,
      "162": 0,
      "163": 0,
      "164": 0,
      "165": 0,
      "166": 0,
      "167": 0,
      "168": 0,
      "169": 0,
      "170": 0,
      "171": 0,
      "172": 0,
      "173": 0,
      "174": 0,
      "175": 0,
      "176": 0,
      "177": 0,
      "178": 0,
      "179": 0,
      "180": 0,
      "181": 0,
      "182": 0,
      "183": 0,
      "184": 0,
      "185": 0,
      "186": 0,
      "187": 0,
      "188": 0,
      "189": 0,
      "190": 0,
      "191": 0,
      "192": 0,
      "193": 0,
      "194": 0,
      "195": 0,
      "196": 0,
      "197": 0,
      "198": 0,
      "199": 0,
      "200": 0,
      "201": 0,
      "202": 0,
      "203": 0,
      "204": 0,
      "205": 0,
      "206": 0,
      "207": 0,
      "208": 0,
      "209": 0,
      "210": 0,
      "211": 0,
      "212": 0,
      "213": 0,
      "214": 0,
      "215": 0,
      "216": 0,
      "217": 0,
      "218": 0,
      "219": 0,
      "220": 0,
      "221": 0,
      "222": 0,
      "223": 0,
      "224": 0,
      "225": 0,
      "226": 0,
      "227": 0,
      "228": 0,
      "229": 0,
      "230": 0,
      "231": 0,
      "232": 0,
      "233": 0,
      "234": 0,
      "235": 0,
      "236": 0,
      "237": 0,
      "238": 0,
      "239": 0,
      "240": 0,
      "241": 0,
      "242": 0,
      "243": 0,
      "244": 0,
      "245": 0,
      "246": 0,
      "247": 0,
      "248": 0,
      "249": 0,
      "250": 0,
      "251": 0,
      "252": 0,
      "253": 0,
      "254": 0,
      "255": 0,
      "256": 0,
      "257": 0,
      "258": 0,
      "259": 0,
      "260": 0,
      "261": 0,
      "262": 0,
      "263": 0,
      "264": 0,
      "265": 0,
      "266": 0,
      "267": 0,
      "268": 0,
      "269": 0,
      "270": 0,
      "271": 0,
      "272": 0,
      "273": 0,
      "274": 0,
      "275": 0,
      "276": 0,
      "277": 0,
      "278": 0,
      "279": 0,
      "280": 0,
      "281": 0,
      "282": 0,
      "283": 0,
      "284": 0,
      "285": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0,
      "41": 0,
      "42": 0,
      "43": 0,
      "44": 0,
      "45": 0,
      "46": 0,
      "47": 0,
      "48": 0,
      "49": 0,
      "50": 0,
      "51": 0,
      "52": 0,
      "53": 0,
      "54": 0,
      "55": 0,
      "56": 0,
      "57": 0,
      "58": 0,
      "59": 0,
      "60": 0,
      "61": 0,
      "62": 0,
      "63": 0,
      "64": 0,
      "65": 0,
      "66": 0,
      "67": 0,
      "68": 0,
      "69": 0,
      "70": 0,
      "71": 0,
      "72": 0,
      "73": 0,
      "74": 0,
      "75": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0, 0],
      "9": [0, 0],
      "10": [0, 0],
      "11": [0, 0],
      "12": [0, 0],
      "13": [0, 0],
      "14": [0, 0],
      "15": [0, 0],
      "16": [0, 0],
      "17": [0, 0],
      "18": [0, 0],
      "19": [0, 0],
      "20": [0, 0],
      "21": [0, 0, 0],
      "22": [0, 0],
      "23": [0, 0],
      "24": [0, 0],
      "25": [0, 0, 0, 0, 0, 0],
      "26": [0, 0],
      "27": [0, 0],
      "28": [0, 0],
      "29": [0, 0],
      "30": [0, 0, 0],
      "31": [0, 0],
      "32": [0, 0],
      "33": [0, 0],
      "34": [0, 0],
      "35": [0, 0],
      "36": [0, 0],
      "37": [0, 0],
      "38": [0, 0],
      "39": [0, 0],
      "40": [0, 0],
      "41": [0, 0],
      "42": [0, 0],
      "43": [0, 0],
      "44": [0, 0],
      "45": [0, 0],
      "46": [0, 0],
      "47": [0, 0],
      "48": [0, 0],
      "49": [0, 0],
      "50": [0, 0],
      "51": [0, 0],
      "52": [0, 0],
      "53": [0, 0],
      "54": [0, 0],
      "55": [0, 0],
      "56": [0, 0],
      "57": [0, 0],
      "58": [0, 0],
      "59": [0, 0],
      "60": [0, 0],
      "61": [0, 0, 0, 0],
      "62": [0, 0],
      "63": [0, 0],
      "64": [0, 0],
      "65": [0, 0],
      "66": [0, 0],
      "67": [0, 0],
      "68": [0, 0],
      "69": [0, 0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "84f52b1dc559744a814a121a30e57c45b1a23c5a"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_2qlmi16o15 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_2qlmi16o15();
function ownKeys(e, r) { var t = _Object$keys2(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
cov_2qlmi16o15().s[0]++;
var getSectionProductIds = function getSectionProductIds(section) {
  cov_2qlmi16o15().f[0]++;
  cov_2qlmi16o15().s[1]++;
  if ((cov_2qlmi16o15().b[1][0]++, !section) || (cov_2qlmi16o15().b[1][1]++, (0, _size.default)(section.clusters) === 0)) {
    cov_2qlmi16o15().b[0][0]++;
    cov_2qlmi16o15().s[2]++;
    return [];
  } else {
    cov_2qlmi16o15().b[0][1]++;
  }
  var productIds = (cov_2qlmi16o15().s[3]++, []);
  cov_2qlmi16o15().s[4]++;
  section.clusters.forEach(function (cluster) {
    cov_2qlmi16o15().f[1]++;
    cov_2qlmi16o15().s[5]++;
    if ((0, _size.default)(cluster.items) === 0) {
      cov_2qlmi16o15().b[2][0]++;
      cov_2qlmi16o15().s[6]++;
      return;
    } else {
      cov_2qlmi16o15().b[2][1]++;
    }
    cov_2qlmi16o15().s[7]++;
    cluster.items.forEach(function (item) {
      cov_2qlmi16o15().f[2]++;
      cov_2qlmi16o15().s[8]++;
      productIds.push(item.product.id);
    });
  });
  cov_2qlmi16o15().s[9]++;
  return productIds;
};

/**
 * After filter or any action that refresh product list data
 * => Update select product id to ensure that select product id still in section product
 */
cov_2qlmi16o15().s[10]++;
var updateSectionSelectProductIds = function updateSectionSelectProductIds(section, products) {
  cov_2qlmi16o15().f[3]++;
  cov_2qlmi16o15().s[11]++;
  // When products === null => this is action before load product to clear data => not update in this case
  if ((cov_2qlmi16o15().b[4][0]++, (0, _size.default)(section.selectProductIds) > 0) && (cov_2qlmi16o15().b[4][1]++, products !== null)) {
    cov_2qlmi16o15().b[3][0]++;
    cov_2qlmi16o15().s[12]++;
    return new _set.default((0, _intersection.default)(getSectionProductIds(section), (0, _toConsumableArray2.default)(section.selectProductIds)));
  } else {
    cov_2qlmi16o15().b[3][1]++;
  }
  cov_2qlmi16o15().s[13]++;
  return section.selectProductIds;
};

/**
 * Model to generate and adapt ClusterItemType
 */
var ClusterItemModel = (cov_2qlmi16o15().s[14]++, {
  /**
   * This function is used to transform cluster item received by the server to cluster item that will be used in
   * the nucleo (state) and all the functional components
   * @param {object} data, it is the value of clusterItem received by the server
   * @param {ConfigType} config, it is the nucleo config object
   * @returns ClusterItemType
   */
  get: function get(data, config) {
    cov_2qlmi16o15().f[4]++;
    var adaptedData = (cov_2qlmi16o15().s[15]++, {
      product: _product.ProductModel.get(data.product, config)
    });
    cov_2qlmi16o15().s[16]++;
    return _objectSpread(_objectSpread({}, data), adaptedData);
  },
  /**
   * This function is used to change the language of cluster item
   * @param {ClusterItemType} clusterItem, value of the nucleo
   * @param {string} language, the first language to try to get
   * @param {string} defaultLanguage, the fallback language if not exist
   * @returns ClusterItemType
   */
  changeLanguage: function changeLanguage(clusterItem, language, defaultLanguage) {
    cov_2qlmi16o15().f[5]++;
    var adaptedData = (cov_2qlmi16o15().s[17]++, {
      product: _product.ProductModel.changeLanguage(clusterItem.product, language, defaultLanguage)
    });
    cov_2qlmi16o15().s[18]++;
    return _objectSpread(_objectSpread({}, clusterItem), adaptedData);
  }
});

/**
 * Model to generate and adapt ClusterType
 */
var ClusterModel = exports.ClusterModel = (cov_2qlmi16o15().s[19]++, {
  /**
   * This function is used to transform cluster received by the server to cluster that will be used in
   * the nucleo (state) and all the functional components
   * @param {object} data, it is the value of cluster received by the server
   * @param {ConfigType} config, it is the nucleo config object
   * @returns ClusterType
   */
  get: function get(data, config) {
    cov_2qlmi16o15().f[6]++;
    var _ref = (cov_2qlmi16o15().s[20]++, config),
      language = _ref.language,
      defaultLanguage = _ref.defaultLanguage;
    var adaptedData = (cov_2qlmi16o15().s[21]++, {
      // get the translated objects to avoid computing it everywhere, but keep all translations
      rawName: data.name,
      name: (cov_2qlmi16o15().b[5][0]++, data.name) && ((cov_2qlmi16o15().b[5][1]++, data.name[language]) || (cov_2qlmi16o15().b[5][2]++, data.name[defaultLanguage]))
    });
    cov_2qlmi16o15().s[22]++;
    if ((cov_2qlmi16o15().b[7][0]++, data.items) && (cov_2qlmi16o15().b[7][1]++, data.items.length > 0)) {
      cov_2qlmi16o15().b[6][0]++;
      cov_2qlmi16o15().s[23]++;
      adaptedData.items = data.items.map(function (clusterItem) {
        cov_2qlmi16o15().f[7]++;
        cov_2qlmi16o15().s[24]++;
        return ClusterItemModel.get(clusterItem, config);
      });
    } else {
      cov_2qlmi16o15().b[6][1]++;
    }
    cov_2qlmi16o15().s[25]++;
    return _objectSpread(_objectSpread({}, data), adaptedData);
  },
  /**
   * This function is used to change the language of cluster item
   * @param {ClusterType} value of the nucleo
   * @param {string} language, the first language to try to get
   * @param {string} defaultLanguage, the fallback language if not exist
   * @returns ClusterType
   */
  changeLanguage: function changeLanguage(cluster, language, defaultLanguage) {
    cov_2qlmi16o15().f[8]++;
    var adaptedData = (cov_2qlmi16o15().s[26]++, {
      name: (cov_2qlmi16o15().b[8][0]++, cluster.rawName) && ((cov_2qlmi16o15().b[8][1]++, cluster.rawName[language]) || (cov_2qlmi16o15().b[8][2]++, cluster.rawName[defaultLanguage]))
    });
    cov_2qlmi16o15().s[27]++;
    if ((cov_2qlmi16o15().b[10][0]++, cluster.items) && (cov_2qlmi16o15().b[10][1]++, cluster.items.length > 0)) {
      cov_2qlmi16o15().b[9][0]++;
      cov_2qlmi16o15().s[28]++;
      adaptedData.items = cluster.items.map(function (clusterItem) {
        cov_2qlmi16o15().f[9]++;
        cov_2qlmi16o15().s[29]++;
        return ClusterItemModel.changeLanguage(clusterItem, language, defaultLanguage);
      });
    } else {
      cov_2qlmi16o15().b[9][1]++;
    }
    cov_2qlmi16o15().s[30]++;
    return _objectSpread(_objectSpread({}, cluster), adaptedData);
  },
  /**
   * This function is used to generate a cluster from a definition and products reference
   * @param {object} name, the map by language like ({en : .. , fr : .., ..})
   * @param {object} clusterDef, a definition of cluster, gotten from calendar endpoint
   * @param {object} products, a map of number(productId) of ProductType
   * @param {ConfigType} config, it is the nucleo config object
   * @returns ClusterType
   */
  buildCluster: function buildCluster(name, clusterDef, products, config) {
    cov_2qlmi16o15().f[10]++;
    var productMap = (cov_2qlmi16o15().s[31]++, {});
    cov_2qlmi16o15().s[32]++;
    products.forEach(function (product) {
      cov_2qlmi16o15().f[11]++;
      cov_2qlmi16o15().s[33]++;
      productMap[product.id] = product;
    });
    var clusterItems = (cov_2qlmi16o15().s[34]++, []);
    cov_2qlmi16o15().s[35]++;
    clusterDef.productOccurrences.forEach(function (clusterItemDef) {
      cov_2qlmi16o15().f[12]++;
      var curProduct = (cov_2qlmi16o15().s[36]++, productMap[clusterItemDef.productId]);
      cov_2qlmi16o15().s[37]++;
      if (config.withTourOnly) {
        cov_2qlmi16o15().b[11][0]++;
        var occurrences = (cov_2qlmi16o15().s[38]++, curProduct.products.reduce(function (acc, tourProduct) {
          cov_2qlmi16o15().f[13]++;
          cov_2qlmi16o15().s[39]++;
          return acc.concat((cov_2qlmi16o15().b[12][0]++, tourProduct.timeslots) || (cov_2qlmi16o15().b[12][1]++, []), (cov_2qlmi16o15().b[13][0]++, tourProduct.performances) || (cov_2qlmi16o15().b[13][1]++, []));
        }, []).filter(function (occurrence) {
          cov_2qlmi16o15().f[14]++;
          cov_2qlmi16o15().s[40]++;
          return clusterItemDef.occurrenceIds.includes((cov_2qlmi16o15().b[14][0]++, occurrence.id) || (cov_2qlmi16o15().b[14][1]++, occurrence.performanceId));
        } // in case of performance
        ));
        cov_2qlmi16o15().s[41]++;
        clusterItems.push({
          displayAs: 'TOUR',
          product: (0, _assign.default)({}, curProduct, {
            occurrences: occurrences
          })
        });
      } else {
        cov_2qlmi16o15().b[11][1]++;
        cov_2qlmi16o15().s[42]++;
        if ((cov_2qlmi16o15().b[16][0]++, (0, _isArray.default)(curProduct.timeslots)) && (cov_2qlmi16o15().b[16][1]++, curProduct.timeslots.length > 0)) {
          cov_2qlmi16o15().b[15][0]++;
          // filter the timeslot to get only those of this day
          var timeslots = (cov_2qlmi16o15().s[43]++, curProduct.timeslots.filter(function (timeslot) {
            cov_2qlmi16o15().f[15]++;
            cov_2qlmi16o15().s[44]++;
            return clusterItemDef.occurrenceIds.includes(timeslot.id);
          }));
          // then for each timeslot add it to the cluster item
          cov_2qlmi16o15().s[45]++;
          clusterItems.push({
            displayAs: timeslots.length === 1 ? (cov_2qlmi16o15().b[17][0]++, 'PERFORMANCE') : (cov_2qlmi16o15().b[17][1]++, 'PRODUCT'),
            product: (0, _assign.default)({}, curProduct, {
              timeslots: timeslots
            })
          });
        } else {
          cov_2qlmi16o15().b[15][1]++;
          cov_2qlmi16o15().s[46]++;
          if ((cov_2qlmi16o15().b[19][0]++, (0, _isArray.default)(curProduct.performances)) && (cov_2qlmi16o15().b[19][1]++, curProduct.performances.length > 0)) {
            cov_2qlmi16o15().b[18][0]++;
            // filter the performance to get only those of this day
            var performances = (cov_2qlmi16o15().s[47]++, curProduct.performances.filter(function (perf) {
              cov_2qlmi16o15().f[16]++;
              cov_2qlmi16o15().s[48]++;
              return clusterItemDef.occurrenceIds.includes(perf.performanceId);
            }));
            // then for each performance add it to the cluster item
            // if there is only one performance, display performance style
            cov_2qlmi16o15().s[49]++;
            clusterItems.push({
              displayAs: performances.length === 1 ? (cov_2qlmi16o15().b[20][0]++, 'PERFORMANCE') : (cov_2qlmi16o15().b[20][1]++, 'PRODUCT'),
              product: (0, _assign.default)({}, curProduct, {
                performances: performances
              })
            });
          } else {
            cov_2qlmi16o15().b[18][1]++;
          }
        }
      }
    });
    cov_2qlmi16o15().s[50]++;
    clusterItems.sort(function (item1, item2) {
      cov_2qlmi16o15().f[17]++;
      cov_2qlmi16o15().s[51]++;
      return _product.ProductModel.isBefore(item1.product, item2.product, config);
    });
    cov_2qlmi16o15().s[52]++;
    return ClusterModel.get({
      name: name,
      items: clusterItems,
      quantity: clusterDef.numberOfOccurrences
    }, config);
  }
});

/**
 * Model to generate and adapt SectionType
 */
var SectionModel = (cov_2qlmi16o15().s[53]++, {
  /**
   * This function is used to transform section received by the server to section that will be used in
   * the nucleo (state) and all the functional components
   * @param {object} data, it is the value of section received by the server
   * @param {ConfigType} config, it is the nucleo config object
   * @returns SectionType
   */
  get: function get(data, config) {
    cov_2qlmi16o15().f[18]++;
    var _ref2 = (cov_2qlmi16o15().s[54]++, config),
      language = _ref2.language,
      defaultLanguage = _ref2.defaultLanguage;
    var adaptedData = (cov_2qlmi16o15().s[55]++, {
      // get the translated objects to avoid computing it everywhere, but keep all translations
      rawName: data.name,
      name: (cov_2qlmi16o15().b[21][0]++, data.name) && ((cov_2qlmi16o15().b[21][1]++, data.name[language]) || (cov_2qlmi16o15().b[21][2]++, data.name[defaultLanguage]))
    });
    cov_2qlmi16o15().s[56]++;
    if ((cov_2qlmi16o15().b[23][0]++, data.clusters) && (cov_2qlmi16o15().b[23][1]++, data.clusters.length > 0)) {
      cov_2qlmi16o15().b[22][0]++;
      cov_2qlmi16o15().s[57]++;
      // the backend return the clusters how they have been defined
      // But in the front-end we want to have a cluster defined by how they are displayed (classified)
      adaptedData.clusters = SectionModel.getClusters(data.clusters, data.classifyBy, config).map(function (cluster) {
        cov_2qlmi16o15().f[19]++;
        cov_2qlmi16o15().s[58]++;
        return ClusterModel.get(cluster, config);
      });
    } else {
      cov_2qlmi16o15().b[22][1]++;
    }
    cov_2qlmi16o15().s[59]++;
    return _objectSpread(_objectSpread({}, data), adaptedData);
  },
  // TODO : refactor, the change language should be applied on only one section
  /**
   * This function is used to change the language of a list of section
   * @param {[SectionType]} sections, value of the nucleo
   * @param {string} language, the first language to try to get
   * @param {string} defaultLanguage, the fallback language if not exist
   * @returns [SectionType]
   */
  changeLanguage: function changeLanguage(language, defaultLanguage, sections) {
    cov_2qlmi16o15().f[20]++;
    cov_2qlmi16o15().s[60]++;
    return sections.map(function (section) {
      cov_2qlmi16o15().f[21]++;
      var parsed = (cov_2qlmi16o15().s[61]++, _objectSpread({}, section));
      cov_2qlmi16o15().s[62]++;
      parsed.name = (cov_2qlmi16o15().b[24][0]++, parsed.rawName[language]) || (cov_2qlmi16o15().b[24][1]++, parsed.rawName[defaultLanguage]);
      cov_2qlmi16o15().s[63]++;
      parsed.clusters = parsed.clusters.map(function (cluster) {
        cov_2qlmi16o15().f[22]++;
        cov_2qlmi16o15().s[64]++;
        return ClusterModel.changeLanguage(cluster, language, defaultLanguage);
      });
      cov_2qlmi16o15().s[65]++;
      return parsed;
    });
  },
  /**
   * Get a cluster representation that suits to the current need
   * Based on the classifyBy, the products will be grouped with a different meaning
   * @param {array(Object)} clustersData, data directly received by the server, transform into the
   * @param {string} classifyBy, the grouping attribute possible values : [FAMILY, DATE, DAY, NONE, CLUSTER]
   * @param {ConfigType} config, it is the nucleo config object
   * @return array(Object) !!! is it not the ClusterType, the result must be computed afterwards based on the ClusterModel.get()
   */
  getClusters: function getClusters(clustersData, classifyBy, config) {
    cov_2qlmi16o15().f[23]++;
    var _ref3 = (cov_2qlmi16o15().s[66]++, config),
      language = _ref3.language,
      defaultLanguage = _ref3.defaultLanguage;
    var name = (cov_2qlmi16o15().s[67]++, {});
    // based on the classify by, create clusterData that represent a ...
    cov_2qlmi16o15().s[68]++;
    switch (classifyBy) {
      // group by product family
      case 'FAMILY':
        cov_2qlmi16o15().b[25][0]++;
        cov_2qlmi16o15().s[69]++;
        return SectionModel.getFamilyClusters(clustersData, config);
      // group by date and create 4 clusters :  today / tomorrow / afterTomorrow / after
      case 'DATE':
        cov_2qlmi16o15().b[25][1]++;
        cov_2qlmi16o15().s[70]++;
        return SectionModel.getDateClusters(clustersData, config);
      // merge products by day, each cluster
      case 'DAY':
        cov_2qlmi16o15().b[25][2]++;
        cov_2qlmi16o15().s[71]++;
        return SectionModel.getDayClusters(clustersData, config);
      // merge all products to have only one cluster that contains everything
      case 'NONE':
        cov_2qlmi16o15().b[25][3]++;
        cov_2qlmi16o15().s[72]++;
        name[language] = '';
        cov_2qlmi16o15().s[73]++;
        name[defaultLanguage] = '';
        // TODO : merge product too; if we have two time the same product, it should not be displayed two times
        cov_2qlmi16o15().s[74]++;
        return [{
          name: name,
          items: (0, _flatten.default)(clustersData.map(function (cluster) {
            cov_2qlmi16o15().f[24]++;
            cov_2qlmi16o15().s[75]++;
            return cluster.items;
          }))
        }];
      // return the clusters without modification
      case 'CLUSTER':
        cov_2qlmi16o15().b[25][4]++;
      default:
        cov_2qlmi16o15().b[25][5]++;
        cov_2qlmi16o15().s[76]++;
        return clustersData;
    }
  },
  /**
   * group product inside clusters of product families, each cluster represent a product family expect
   * Timeslot_pass and pass are merged and
   * visit and visit_pass are merged too
   * @param {array(Object)} clustersData, data directly received by the server, transform into the
   * @param {ConfigType} config, it is the nucleo config object
   * @return array(Object) !!! is it not the ClusterType, the result must be computed afterwards based on the ClusterModel.get()
   */
  getFamilyClusters: function getFamilyClusters(clustersData, config) {
    cov_2qlmi16o15().f[25]++;
    var _ref4 = (cov_2qlmi16o15().s[77]++, config),
      language = _ref4.language,
      defaultLanguage = _ref4.defaultLanguage;
    var newClusters = (cov_2qlmi16o15().s[78]++, {});
    cov_2qlmi16o15().s[79]++;
    clustersData.forEach(function (cluster) {
      cov_2qlmi16o15().f[26]++;
      cov_2qlmi16o15().s[80]++;
      cluster.items.forEach(function (item) {
        cov_2qlmi16o15().f[27]++;
        // product family
        var pf = (cov_2qlmi16o15().s[81]++, item.product.productType);
        // override timeslot pass and consider it as a pass (for merging similar objects)
        cov_2qlmi16o15().s[82]++;
        if (pf === 'TIMESLOT_PASS') {
          cov_2qlmi16o15().b[26][0]++;
          cov_2qlmi16o15().s[83]++;
          pf = 'PASS';
        } else {
          cov_2qlmi16o15().b[26][1]++;
        }
        // override visit_pass and consider it as a visit (for merging similar objects)
        cov_2qlmi16o15().s[84]++;
        if (pf === 'VISIT_PASS') {
          cov_2qlmi16o15().b[27][0]++;
          cov_2qlmi16o15().s[85]++;
          pf = 'VISIT';
        } else {
          cov_2qlmi16o15().b[27][1]++;
        }
        var name = (cov_2qlmi16o15().s[86]++, {});
        cov_2qlmi16o15().s[87]++;
        name[language] = pf;
        cov_2qlmi16o15().s[88]++;
        name[defaultLanguage] = pf;
        cov_2qlmi16o15().s[89]++;
        newClusters[pf] = (cov_2qlmi16o15().b[28][0]++, newClusters[pf]) || (cov_2qlmi16o15().b[28][1]++, {
          name: name,
          items: []
        });
        cov_2qlmi16o15().s[90]++;
        newClusters[pf].items.push(item);
      });
    });
    cov_2qlmi16o15().s[91]++;
    return (0, _values.default)(newClusters);
  },
  /**
   * group product inside clusters, based on the date of performances, we get 4 clusters : today, tomorrow, after tomorrow, after
   * If a product has occurrence inside different days, duplicate product
   * @param {array(Object)} clustersData, data directly received by the server, transform into the
   * @param {ConfigType} config, it is the nucleo config object
   * @return array(Object) !!! is it not the ClusterType, the result must be computed afterwards based on the ClusterModel.get()
   */
  getDateClusters: function getDateClusters(clusters, config) {
    cov_2qlmi16o15().f[28]++;
    var _ref5 = (cov_2qlmi16o15().s[92]++, config),
      language = _ref5.language,
      defaultLanguage = _ref5.defaultLanguage,
      serverTimeZoneOffset = _ref5.serverTimeZoneOffset;
    var timeZoneOffset = (cov_2qlmi16o15().s[93]++, (cov_2qlmi16o15().b[29][0]++, serverTimeZoneOffset) || (cov_2qlmi16o15().b[29][1]++, 3600000));
    var items = (cov_2qlmi16o15().s[94]++, (0, _flatten.default)(clusters.map(function (cluster) {
      cov_2qlmi16o15().f[29]++;
      cov_2qlmi16o15().s[95]++;
      return cluster.items;
    })));
    var todayLocal = (cov_2qlmi16o15().s[96]++, new Date());
    var todayUTC = (cov_2qlmi16o15().s[97]++, todayLocal.getTime() + todayLocal.getTimezoneOffset() * 60000);
    var today = (cov_2qlmi16o15().s[98]++, new Date(todayUTC + timeZoneOffset));
    cov_2qlmi16o15().s[99]++;
    var isToday = function isToday(date) {
      cov_2qlmi16o15().f[30]++;
      cov_2qlmi16o15().s[100]++;
      return (0, _difference_in_calendar_days.default)(date, today) === 0;
    };
    cov_2qlmi16o15().s[101]++;
    var isTomorrow = function isTomorrow(date) {
      cov_2qlmi16o15().f[31]++;
      cov_2qlmi16o15().s[102]++;
      return (0, _difference_in_calendar_days.default)(date, today) === 1;
    };
    cov_2qlmi16o15().s[103]++;
    var isAfterTomorrow = function isAfterTomorrow(date) {
      cov_2qlmi16o15().f[32]++;
      cov_2qlmi16o15().s[104]++;
      return (0, _difference_in_calendar_days.default)(date, today) === 2;
    };
    cov_2qlmi16o15().s[105]++;
    var isLater = function isLater(date) {
      cov_2qlmi16o15().f[33]++;
      cov_2qlmi16o15().s[106]++;
      return (cov_2qlmi16o15().b[30][0]++, !isToday(date)) && (cov_2qlmi16o15().b[30][1]++, !isTomorrow(date)) && (cov_2qlmi16o15().b[30][2]++, !isAfterTomorrow(date));
    };
    var itemsByDate = (cov_2qlmi16o15().s[107]++, {
      today: [],
      tomorrow: [],
      afterTomorrow: [],
      later: []
    });
    cov_2qlmi16o15().s[108]++;
    items.forEach(function (item) {
      cov_2qlmi16o15().f[34]++;
      var hasToday = (cov_2qlmi16o15().s[109]++, false);
      var hasTomorrow = (cov_2qlmi16o15().s[110]++, false);
      var hasAfterTomorrow = (cov_2qlmi16o15().s[111]++, false);

      // if any occurence in the specified date, add the item to the list of product for the specified date
      cov_2qlmi16o15().s[112]++;
      _product.ProductModel.getOccurrences(item.product).forEach(function (occ) {
        cov_2qlmi16o15().f[35]++;
        cov_2qlmi16o15().s[113]++;
        if ((cov_2qlmi16o15().b[32][0]++, !hasToday) && (cov_2qlmi16o15().b[32][1]++, isToday(occ.start.split('T')[0]))) {
          cov_2qlmi16o15().b[31][0]++;
          cov_2qlmi16o15().s[114]++;
          hasToday = true;
          cov_2qlmi16o15().s[115]++;
          itemsByDate.today.push(item);
        } else {
          cov_2qlmi16o15().b[31][1]++;
        }
        cov_2qlmi16o15().s[116]++;
        if ((cov_2qlmi16o15().b[34][0]++, !hasTomorrow) && (cov_2qlmi16o15().b[34][1]++, isTomorrow(occ.start.split('T')[0]))) {
          cov_2qlmi16o15().b[33][0]++;
          cov_2qlmi16o15().s[117]++;
          hasTomorrow = true;
          cov_2qlmi16o15().s[118]++;
          itemsByDate.tomorrow.push(item);
        } else {
          cov_2qlmi16o15().b[33][1]++;
        }
        cov_2qlmi16o15().s[119]++;
        if ((cov_2qlmi16o15().b[36][0]++, !hasAfterTomorrow) && (cov_2qlmi16o15().b[36][1]++, isAfterTomorrow(occ.start.split('T')[0]))) {
          cov_2qlmi16o15().b[35][0]++;
          cov_2qlmi16o15().s[120]++;
          hasAfterTomorrow = true;
          cov_2qlmi16o15().s[121]++;
          itemsByDate.afterTomorrow.push(item);
        } else {
          cov_2qlmi16o15().b[35][1]++;
        }
      });
      var lastDate = (cov_2qlmi16o15().s[122]++, (cov_2qlmi16o15().b[37][0]++, item.product) && (cov_2qlmi16o15().b[37][1]++, item.product.lastDate));
      // base the isLater on the item last date, the product may no content the occurences even if they are salable.
      cov_2qlmi16o15().s[123]++;
      if ((cov_2qlmi16o15().b[39][0]++, lastDate) && (cov_2qlmi16o15().b[39][1]++, isLater(lastDate.split('T')[0]))) {
        cov_2qlmi16o15().b[38][0]++;
        cov_2qlmi16o15().s[124]++;
        itemsByDate.later.push(item);
      } else {
        cov_2qlmi16o15().b[38][1]++;
      }
    });
    var newClusters = (cov_2qlmi16o15().s[125]++, []);
    // convenient to get the function in the following loop, filter performances by day
    var isDayFnList = (cov_2qlmi16o15().s[126]++, {
      today: isToday,
      tomorrow: isTomorrow,
      afterTomorrow: isAfterTomorrow,
      later: function later() {
        cov_2qlmi16o15().f[36]++;
        cov_2qlmi16o15().s[127]++;
        return false;
      } // for later, we don't want to have the performances or timeslots
    });
    cov_2qlmi16o15().s[128]++;
    ['today', 'tomorrow', 'afterTomorrow', 'later'].forEach(function (day) {
      cov_2qlmi16o15().f[37]++;
      cov_2qlmi16o15().s[129]++;
      if (itemsByDate[day].length === 0) {
        cov_2qlmi16o15().b[40][0]++;
        cov_2qlmi16o15().s[130]++;
        return;
      } else {
        cov_2qlmi16o15().b[40][1]++;
      }
      var dayCheck = (cov_2qlmi16o15().s[131]++, isDayFnList[day]);
      cov_2qlmi16o15().s[132]++;
      var isNotEmpty = function isNotEmpty(arr) {
        cov_2qlmi16o15().f[38]++;
        cov_2qlmi16o15().s[133]++;
        return (cov_2qlmi16o15().b[41][0]++, arr) && (cov_2qlmi16o15().b[41][1]++, !(0, _isEmpty.default)(arr));
      };
      var newItems = (cov_2qlmi16o15().s[134]++, itemsByDate[day].map(function (item) {
        cov_2qlmi16o15().f[39]++;
        var newItem = (cov_2qlmi16o15().s[135]++, {
          displayAs: item.displayAs
        });
        cov_2qlmi16o15().s[136]++;
        newItem.product = (0, _clone.default)(item.product);
        cov_2qlmi16o15().s[137]++;
        var filterFn = function filterFn(occ) {
          cov_2qlmi16o15().f[40]++;
          cov_2qlmi16o15().s[138]++;
          return dayCheck(occ.start.split('T')[0]);
        };
        cov_2qlmi16o15().s[139]++;
        if (isNotEmpty(newItem.product.performances)) {
          cov_2qlmi16o15().b[42][0]++;
          cov_2qlmi16o15().s[140]++;
          newItem.product.performances = newItem.product.performances.filter(filterFn);
        } else {
          cov_2qlmi16o15().b[42][1]++;
        }
        cov_2qlmi16o15().s[141]++;
        if (isNotEmpty(newItem.product.timeslots)) {
          cov_2qlmi16o15().b[43][0]++;
          cov_2qlmi16o15().s[142]++;
          newItem.product.timeslots = newItem.product.timeslots.filter(filterFn);
        } else {
          cov_2qlmi16o15().b[43][1]++;
        }
        cov_2qlmi16o15().s[143]++;
        if (isNotEmpty(newItem.product.occurrences)) {
          cov_2qlmi16o15().b[44][0]++;
          cov_2qlmi16o15().s[144]++;
          newItem.product.occurrences = newItem.product.occurrences.filter(filterFn);
        } else {
          cov_2qlmi16o15().b[44][1]++;
        }
        cov_2qlmi16o15().s[145]++;
        return newItem;
      }));
      var name = (cov_2qlmi16o15().s[146]++, {});
      cov_2qlmi16o15().s[147]++;
      name[language] = day;
      cov_2qlmi16o15().s[148]++;
      name[defaultLanguage] = day;
      cov_2qlmi16o15().s[149]++;
      newClusters.push({
        name: name,
        items: newItems
      });
    });
    cov_2qlmi16o15().s[150]++;
    return newClusters;
  },
  /**
   * group product inside clusters reprsenting one day each. If a product has occurrence inside different days, duplicate product
   * @param {array(Object)} clustersData, data directly received by the server, transform into the
   * @param {ConfigType} config, it is the nucleo config object
   * @return array(Object) !!! is it not the ClusterType, the result must be computed afterwards based on the ClusterModel.get()
   */
  getDayClusters: function getDayClusters(clusters, config) {
    cov_2qlmi16o15().f[41]++;
    var _ref6 = (cov_2qlmi16o15().s[151]++, config),
      language = _ref6.language,
      defaultLanguage = _ref6.defaultLanguage;
    // contains the list of cluster
    var dayClusters = (cov_2qlmi16o15().s[152]++, []);
    // the map of object
    var clusterByDays = (cov_2qlmi16o15().s[153]++, {});
    // the map of product by clusters
    var clusterProducts = (cov_2qlmi16o15().s[154]++, {});
    // the map of
    cov_2qlmi16o15().s[155]++;
    clusters.forEach(function (cluster) {
      cov_2qlmi16o15().f[42]++;
      cov_2qlmi16o15().s[156]++;
      cluster.items.forEach(function (clusterItem) {
        cov_2qlmi16o15().f[43]++;
        var occurrences = (cov_2qlmi16o15().s[157]++, _product.ProductModel.getOccurrences(clusterItem.product));
        var hasPerf = (cov_2qlmi16o15().s[158]++, clusterItem.product.performances);
        cov_2qlmi16o15().s[159]++;
        if ((cov_2qlmi16o15().b[46][0]++, !occurrences) || (cov_2qlmi16o15().b[46][1]++, occurrences.length === 0)) {
          cov_2qlmi16o15().b[45][0]++;
          cov_2qlmi16o15().s[160]++;
          return;
        } else {
          cov_2qlmi16o15().b[45][1]++;
        }
        var productId = (cov_2qlmi16o15().s[161]++, clusterItem.product.id);
        cov_2qlmi16o15().s[162]++;
        occurrences.forEach(function (occ) {
          cov_2qlmi16o15().f[44]++;
          // the day value is the year followed by the number of days like 2018-085
          var day = (cov_2qlmi16o15().s[163]++, (0, _format.default)(occ.start.split('T')[0], 'YYYY-MM-DD'));
          var newClusterItem = (cov_2qlmi16o15().s[164]++, clusterProducts["".concat(day, "-").concat(productId)]);
          cov_2qlmi16o15().s[165]++;
          if (!newClusterItem) {
            cov_2qlmi16o15().b[47][0]++;
            cov_2qlmi16o15().s[166]++;
            // create a new cluster that only contains the current performance
            newClusterItem = (0, _assign.default)({}, clusterItem, {
              product: (0, _assign.default)({}, clusterItem.product, {
                performances: hasPerf ? (cov_2qlmi16o15().b[48][0]++, [occ]) : (cov_2qlmi16o15().b[48][1]++, null),
                timeslots: hasPerf ? (cov_2qlmi16o15().b[49][0]++, null) : (cov_2qlmi16o15().b[49][1]++, [occ])
              }),
              displayAs: 'PERFORMANCE'
            });
            var dayCluster;
            cov_2qlmi16o15().s[167]++;
            if (clusterByDays[day]) {
              cov_2qlmi16o15().b[50][0]++;
              cov_2qlmi16o15().s[168]++;
              dayCluster = clusterByDays[day];
              cov_2qlmi16o15().s[169]++;
              dayCluster.items.push(newClusterItem);
            } else {
              cov_2qlmi16o15().b[50][1]++;
              var rawName = (cov_2qlmi16o15().s[170]++, {});
              // ensure that it follow the section type
              cov_2qlmi16o15().s[171]++;
              rawName[language] = day;
              cov_2qlmi16o15().s[172]++;
              rawName[defaultLanguage] = day;
              cov_2qlmi16o15().s[173]++;
              dayCluster = {
                name: rawName,
                items: [newClusterItem]
              };
              cov_2qlmi16o15().s[174]++;
              clusterByDays[day] = dayCluster;
              cov_2qlmi16o15().s[175]++;
              dayClusters.push(dayCluster);
            }
          } else {
            cov_2qlmi16o15().b[47][1]++;
            cov_2qlmi16o15().s[176]++;
            // add the occurrence to the current cluster
            ((cov_2qlmi16o15().b[51][0]++, newClusterItem.product.performances) || (cov_2qlmi16o15().b[51][1]++, newClusterItem.product.timeslots)).push(occ);
          }
        });
      });
    });
    cov_2qlmi16o15().s[177]++;
    return dayClusters;
  },
  /**
   * convenient function to get a section representation of a month, from the data of the calendar endpoint
   * @param {object} occurrences, , a definition of occurrence map and value, gotten from calendar endpoint
   * @param {object} products, a map of number(productId) of ProductType
   * @param {ConfigType} config, it is the nucleo config object
   * @return SectionType
   */
  getFromMonth: function getFromMonth(occurrences, products, config) {
    cov_2qlmi16o15().f[45]++;
    var _ref7 = (cov_2qlmi16o15().s[178]++, config),
      language = _ref7.language,
      defaultLanguage = _ref7.defaultLanguage;
    var firstDate = (cov_2qlmi16o15().s[179]++, (0, _utils.convertToUtcDate)((0, _keys.default)(occurrences)[0]));
    var month = (cov_2qlmi16o15().s[180]++, (0, _format.default)(firstDate, 'YYYY-MM'));
    var name = (cov_2qlmi16o15().s[181]++, {});
    cov_2qlmi16o15().s[182]++;
    name[language] = month;
    cov_2qlmi16o15().s[183]++;
    name[defaultLanguage] = month;

    // create the section model before asiggning clusters to avoid double computation of clusters
    var sectionPattern = (cov_2qlmi16o15().s[184]++, SectionModel.get({
      name: name,
      classifyBy: 'DAY',
      displayActionBtn: true,
      randomOrder: false,
      sortByDate: false
    }, language, defaultLanguage));
    var clusters = (cov_2qlmi16o15().s[185]++, (0, _entries.default)(occurrences).map(function (_ref8) {
      var _ref9 = (0, _slicedToArray2.default)(_ref8, 2),
        date = _ref9[0],
        clusterDef = _ref9[1];
      cov_2qlmi16o15().f[46]++;
      var clDate = (cov_2qlmi16o15().s[186]++, (0, _format.default)((0, _utils.convertToUtcDate)(date), 'YYYY-MM-DD'));
      var clusterName = (cov_2qlmi16o15().s[187]++, {});
      cov_2qlmi16o15().s[188]++;
      clusterName[language] = clDate;
      cov_2qlmi16o15().s[189]++;
      clusterName[defaultLanguage] = clDate;
      var prod = (cov_2qlmi16o15().s[190]++, products.map(function (p) {
        cov_2qlmi16o15().f[47]++;
        cov_2qlmi16o15().s[191]++;
        return _calendar.CalendarModel.enhancedProductWithDateParameter(p, date);
      }));
      cov_2qlmi16o15().s[192]++;
      return ClusterModel.buildCluster(clusterName, clusterDef, prod, config);
    }));
    // create the section pattern
    var section = (cov_2qlmi16o15().s[193]++, (0, _assign.default)(sectionPattern, {
      clusters: clusters
    }));

    // use the model to create the section
    cov_2qlmi16o15().s[194]++;
    return section;
  },
  // TODO : remove as soon as we remove tournament catalog
  /**
   * Iterate over the array of products to create a product row for every performance inside the products 'performance' array.
   * @param {array} source, list of products
   *
   * @return {array} List of products with performances inside
   */
  getRowsProduct: function getRowsProduct(source, language, defaultLanguage) {
    cov_2qlmi16o15().f[48]++;
    var products = (cov_2qlmi16o15().s[195]++, (0, _assign.default)([], source));
    var productByRow = (cov_2qlmi16o15().s[196]++, []);
    var items = (cov_2qlmi16o15().s[197]++, []);
    cov_2qlmi16o15().s[198]++;
    products.map(function (product) {
      cov_2qlmi16o15().f[49]++;
      cov_2qlmi16o15().s[199]++;
      return product.performances.forEach(function (performance) {
        cov_2qlmi16o15().f[50]++;
        var parsedProduct = (cov_2qlmi16o15().s[200]++, (0, _assign.default)([], product));
        cov_2qlmi16o15().s[201]++;
        parsedProduct.performances = [performance];
        cov_2qlmi16o15().s[202]++;
        productByRow.push(_product.ProductModel.get(parsedProduct, language, defaultLanguage));
      });
    });
    cov_2qlmi16o15().s[203]++;
    productByRow.forEach(function (product) {
      cov_2qlmi16o15().f[51]++;
      cov_2qlmi16o15().s[204]++;
      product.performances.forEach(function () {
        cov_2qlmi16o15().f[52]++;
        var item = (cov_2qlmi16o15().s[205]++, {
          displayAs: 'PERFORMANCE',
          product: {}
        });
        cov_2qlmi16o15().s[206]++;
        item.product = product;
        cov_2qlmi16o15().s[207]++;
        items.push(item);
      });
    });
    cov_2qlmi16o15().s[208]++;
    return items;
  },
  // allows to merge all the sections in one to handle specific
  // it take the values from the section Pattern or the first section in the list if not provided
  mergeSections: function mergeSections(sections, sectionPattern) {
    cov_2qlmi16o15().f[53]++;
    cov_2qlmi16o15().s[209]++;
    if ((cov_2qlmi16o15().b[53][0]++, sections) && (cov_2qlmi16o15().b[53][1]++, sections.length > 0)) {
      cov_2qlmi16o15().b[52][0]++;
      cov_2qlmi16o15().s[210]++;
      return (0, _assign.default)({}, (cov_2qlmi16o15().b[54][0]++, sectionPattern) || (cov_2qlmi16o15().b[54][1]++, sections[0]), {
        clusters: (0, _flatten.default)(sections.map(function (section) {
          cov_2qlmi16o15().f[54]++;
          cov_2qlmi16o15().s[211]++;
          return section.clusters;
        }))
      });
    } else {
      cov_2qlmi16o15().b[52][1]++;
    }
    cov_2qlmi16o15().s[212]++;
    return {};
  },
  /**
   * @param section
   * @param products
   * @return a new section
   */
  loadProductsIntoSection: function loadProductsIntoSection(section, products, config, generateAllId) {
    cov_2qlmi16o15().f[55]++;
    var newClusterItems = (cov_2qlmi16o15().s[213]++, products.map(function (product) {
      cov_2qlmi16o15().f[56]++;
      cov_2qlmi16o15().s[214]++;
      return {
        product: _product.ProductModel.get(product, config),
        displayAs: 'PRODUCT'
      };
    }));
    // Update clusters
    var clusters = (cov_2qlmi16o15().s[215]++, section.clusters.map(function (cluster) {
      cov_2qlmi16o15().f[57]++;
      cov_2qlmi16o15().s[216]++;
      return _objectSpread(_objectSpread({}, cluster), {}, {
        items: [].concat((0, _toConsumableArray2.default)(cluster.items), (0, _toConsumableArray2.default)(newClusterItems))
      });
    }));
    // Update select product ids
    var selectProductIds = (cov_2qlmi16o15().s[217]++, updateSectionSelectProductIds({
      selectProductIds: section.selectProductIds,
      clusters: clusters
    }, products));
    cov_2qlmi16o15().s[218]++;
    return _objectSpread(_objectSpread({}, section), {}, {
      selectProductIds: selectProductIds,
      clusters: clusters,
      generateAllId: generateAllId
    });
  },
  /**
   * Create a sections based on provided products list
   * @param sectionData: contains id & name of section
   * @param products
   * @param language
   * @param defaultLanguage
   * @return a section
   */
  getSectionForProducts: function getSectionForProducts(sectionData, products, config) {
    cov_2qlmi16o15().f[58]++;
    var _ref10 = (cov_2qlmi16o15().s[219]++, config),
      language = _ref10.language,
      defaultLanguage = _ref10.defaultLanguage;
    var name = (cov_2qlmi16o15().s[220]++, {});
    var sectionName = (cov_2qlmi16o15().s[221]++, sectionData.name);
    cov_2qlmi16o15().s[222]++;
    name[language] = sectionName ? (cov_2qlmi16o15().b[55][0]++, sectionName[language]) : (cov_2qlmi16o15().b[55][1]++, '');
    cov_2qlmi16o15().s[223]++;
    name[defaultLanguage] = sectionName ? (cov_2qlmi16o15().b[56][0]++, sectionName[defaultLanguage]) : (cov_2qlmi16o15().b[56][1]++, '');

    // create the section model before asiggning clusters to avoid double computation of clusters
    var sectionPattern = (cov_2qlmi16o15().s[224]++, SectionModel.get({
      name: name,
      code: String((cov_2qlmi16o15().b[57][0]++, sectionData.id) || (cov_2qlmi16o15().b[57][1]++, sectionData.code)),
      classifyBy: 'NONE',
      randomOrder: false
    }, config));

    // from list products build list cluster item display as product
    var clusterItems = (cov_2qlmi16o15().s[225]++, products.map(function (prod) {
      cov_2qlmi16o15().f[59]++;
      cov_2qlmi16o15().s[226]++;
      return {
        product: _product.ProductModel.get(prod, config),
        displayAs: 'PRODUCT'
      };
    }));

    // build a cluster
    var cluster = (cov_2qlmi16o15().s[227]++, ClusterModel.get({
      name: name,
      layout: 'CARD',
      items: clusterItems,
      quantity: clusterItems.length
    }, config));
    // create the section pattern
    cov_2qlmi16o15().s[228]++;
    return (0, _assign.default)(sectionPattern, {
      clusters: [cluster]
    });
  },
  /**
   * Create an object with a section by month and a cluster per day
   *
   * @param {Object} product,         contain the info of a product
   * @param {String} language,        actual language
   * @param {String} defaultLanguage, default language
   *
   * @return {Object} Object with the key as a month and a Section as value.
   * For example:
   *  {
   *    '2019-09': {
   *       name:...,
   *       classifyBy:...,
   *       displayActionBtn:...,
   *       randomOrder:...,
   *       rawName:...,
   *       clusters: (Array of Cluster)
   *    }
   *  }
   */
  getOccurrencesByMonth: function getOccurrencesByMonth(product, config) {
    cov_2qlmi16o15().f[60]++;
    var _ref11 = (cov_2qlmi16o15().s[229]++, config),
      language = _ref11.language,
      defaultLanguage = _ref11.defaultLanguage;
    // Get the occurrences from performances or timeslots
    var occurrences = (cov_2qlmi16o15().s[230]++, _product.ProductModel.getOccurrences(product));
    var name = (cov_2qlmi16o15().s[231]++, {});
    var sectionByMonth = (cov_2qlmi16o15().s[232]++, {});
    var accumulatedMonth = (cov_2qlmi16o15().s[233]++, '');
    var sectionPattern = (cov_2qlmi16o15().s[234]++, null);

    // First, group the occurrences by date to create the cluster accordingly
    var groupedClusterPerDay = (cov_2qlmi16o15().s[235]++, (0, _groupBy.default)(occurrences, function (occurrence) {
      cov_2qlmi16o15().f[61]++;
      cov_2qlmi16o15().s[236]++;
      return (0, _format.default)(new Date(occurrence.start), 'YYYY-MM-DD');
    }));

    // Iterate for every day
    cov_2qlmi16o15().s[237]++;
    (0, _entries.default)(groupedClusterPerDay).forEach(function (occurrence) {
      cov_2qlmi16o15().f[62]++;
      var cluster = (cov_2qlmi16o15().s[238]++, null);
      var dateOccurrence = (cov_2qlmi16o15().s[239]++, occurrence[0]);
      var occurrencesGrouped = (cov_2qlmi16o15().s[240]++, occurrence[1]);
      // Get the month of occurrence
      var actualMonth = (cov_2qlmi16o15().s[241]++, (0, _format.default)(new Date(dateOccurrence), 'YYYY-MM'));

      // if it is a new month, then create a new Section
      cov_2qlmi16o15().s[242]++;
      if (actualMonth !== accumulatedMonth) {
        cov_2qlmi16o15().b[58][0]++;
        cov_2qlmi16o15().s[243]++;
        accumulatedMonth = actualMonth;
        cov_2qlmi16o15().s[244]++;
        name[language] = actualMonth;
        cov_2qlmi16o15().s[245]++;
        name[defaultLanguage] = actualMonth;

        // create the section model before asiggning clusters to avoid double computation of clusters
        cov_2qlmi16o15().s[246]++;
        sectionPattern = SectionModel.get({
          name: name,
          classifyBy: 'DAY',
          displayActionBtn: true,
          randomOrder: false,
          sortByDate: false
        }, config);
      } else {
        cov_2qlmi16o15().b[58][1]++;
      }
      // For every occurrence, create a new cluster
      var clDate = (cov_2qlmi16o15().s[247]++, (0, _format.default)(new Date(dateOccurrence), 'YYYY-MM-DD'));
      var clusterName = (cov_2qlmi16o15().s[248]++, {});
      var clusterDef = (cov_2qlmi16o15().s[249]++, {});
      var occurrenceIds = (cov_2qlmi16o15().s[250]++, []);

      // Add the occurrence with the same day to the definition
      cov_2qlmi16o15().s[251]++;
      occurrencesGrouped.forEach(function (occurrenceGrouped) {
        cov_2qlmi16o15().f[63]++;
        cov_2qlmi16o15().s[252]++;
        // We need to look for a performanceId (for performances) or id(for othes types)
        occurrenceIds.push((cov_2qlmi16o15().b[59][0]++, occurrenceGrouped.performanceId) || (cov_2qlmi16o15().b[59][1]++, occurrenceGrouped.id));
      });
      cov_2qlmi16o15().s[253]++;
      clusterName[language] = clDate;
      cov_2qlmi16o15().s[254]++;
      clusterName[defaultLanguage] = clDate;
      cov_2qlmi16o15().s[255]++;
      clusterDef.productOccurrences = [{
        productId: product.id,
        occurrenceIds: occurrenceIds
      }];
      cov_2qlmi16o15().s[256]++;
      clusterDef.numberOfOccurrences = occurrenceIds.length;
      // Create the cluster with an only product
      cov_2qlmi16o15().s[257]++;
      cluster = ClusterModel.buildCluster(clusterName, clusterDef, [product], config);
      // Concat the new cluster to the previous one if the section has one
      var clusters = (cov_2qlmi16o15().s[258]++, sectionPattern.clusters ? (cov_2qlmi16o15().b[60][0]++, sectionPattern.clusters.concat(cluster)) : (cov_2qlmi16o15().b[60][1]++, [cluster]));
      // create the section pattern
      cov_2qlmi16o15().s[259]++;
      sectionByMonth[actualMonth] = (0, _assign.default)(sectionPattern, {
        clusters: clusters
      });
    });
    cov_2qlmi16o15().s[260]++;
    return sectionByMonth;
  },
  /*
   * Convenient function to get a specific cluster inside a section
   */
  getCluster: function getCluster(section, clusterName) {
    cov_2qlmi16o15().f[64]++;
    cov_2qlmi16o15().s[261]++;
    return (cov_2qlmi16o15().b[61][0]++, section) && (cov_2qlmi16o15().b[61][1]++, section.clusters) && (cov_2qlmi16o15().b[61][2]++, section.clusters.find) && (cov_2qlmi16o15().b[61][3]++, section.clusters.find(function (cluster) {
      cov_2qlmi16o15().f[65]++;
      cov_2qlmi16o15().s[262]++;
      return cluster.name === clusterName;
    }));
  },
  // assume that if a section has a code defined, the data are filled
  hasData: function hasData(section) {
    cov_2qlmi16o15().f[66]++;
    cov_2qlmi16o15().s[263]++;
    return section.code;
  },
  updateSelectProductIds: function updateSelectProductIds(section, changedProductId, isSelectAllEnabled) {
    cov_2qlmi16o15().f[67]++;
    cov_2qlmi16o15().s[264]++;
    if (!changedProductId) {
      cov_2qlmi16o15().b[62][0]++;
      cov_2qlmi16o15().s[265]++;
      return section;
    } else {
      cov_2qlmi16o15().b[62][1]++;
    }
    var selectProductIds = (cov_2qlmi16o15().s[266]++, (cov_2qlmi16o15().b[63][0]++, section.selectProductIds) || (cov_2qlmi16o15().b[63][1]++, new _set.default()));
    cov_2qlmi16o15().s[267]++;
    if (isSelectAllEnabled === undefined) {
      cov_2qlmi16o15().b[64][0]++;
      cov_2qlmi16o15().s[268]++;
      // Single product select
      if (selectProductIds.has(changedProductId)) {
        cov_2qlmi16o15().b[65][0]++;
        cov_2qlmi16o15().s[269]++;
        selectProductIds.delete(changedProductId);
      } else {
        cov_2qlmi16o15().b[65][1]++;
        cov_2qlmi16o15().s[270]++;
        selectProductIds.add(changedProductId);
      }
    } else {
      cov_2qlmi16o15().b[64][1]++;
      cov_2qlmi16o15().s[271]++;
      if (isSelectAllEnabled) {
        cov_2qlmi16o15().b[66][0]++;
        cov_2qlmi16o15().s[272]++;
        // Select all
        getSectionProductIds(section).forEach(function (productId) {
          cov_2qlmi16o15().f[68]++;
          cov_2qlmi16o15().s[273]++;
          return selectProductIds.add(productId);
        });
      } else {
        cov_2qlmi16o15().b[66][1]++;
        cov_2qlmi16o15().s[274]++;
        // Deselect all
        selectProductIds.clear();
      }
    }
    cov_2qlmi16o15().s[275]++;
    return _objectSpread(_objectSpread({}, section), {}, {
      selectProductIds: selectProductIds
    });
  },
  /**
   * Return a array of product of section that match with productIds or all product (if not pass productIds)
   */
  getRawProducts: function getRawProducts(section, productIds) {
    cov_2qlmi16o15().f[69]++;
    cov_2qlmi16o15().s[276]++;
    return (0, _flatten.default)(section.clusters.map(function (cluster) {
      cov_2qlmi16o15().f[70]++;
      var clusterProducts = (cov_2qlmi16o15().s[277]++, cluster.items.map(function (item) {
        cov_2qlmi16o15().f[71]++;
        cov_2qlmi16o15().s[278]++;
        return item.product;
      }));
      cov_2qlmi16o15().s[279]++;
      if (productIds) {
        cov_2qlmi16o15().b[67][0]++;
        cov_2qlmi16o15().s[280]++;
        return clusterProducts.filter(function (product) {
          cov_2qlmi16o15().f[72]++;
          cov_2qlmi16o15().s[281]++;
          return (cov_2qlmi16o15().b[68][0]++, productIds) && (cov_2qlmi16o15().b[68][1]++, productIds.has(product.id));
        });
      } else {
        cov_2qlmi16o15().b[67][1]++;
      }
      cov_2qlmi16o15().s[282]++;
      return clusterProducts;
    }));
  },
  /**
   * Return a array of select product of 1 section or all section (if not pass sectionCode)
   */
  getSelectProducts: function getSelectProducts(sections, sectionCode) {
    cov_2qlmi16o15().f[73]++;
    cov_2qlmi16o15().s[283]++;
    return (0, _flatten.default)(sections.filter(function (section) {
      cov_2qlmi16o15().f[74]++;
      cov_2qlmi16o15().s[284]++;
      return ((cov_2qlmi16o15().b[69][0]++, !sectionCode) || (cov_2qlmi16o15().b[69][1]++, section.code === sectionCode)) && (cov_2qlmi16o15().b[69][2]++, (0, _size.default)(section.selectProductIds) > 0);
    }).map(function (section) {
      cov_2qlmi16o15().f[75]++;
      cov_2qlmi16o15().s[285]++;
      return SectionModel.getRawProducts(section, section.selectProductIds);
    }));
  }
});
var _default = exports.default = SectionModel;